/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 5 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import { useTranslation, untranslated } from "@i18n";
import { useDispatch, useSelector } from "react-redux";
import { useRef, useState, useEffect, forwardRef, lazy, Suspense, useCallback } from "react";

import DsrPopup from "./DsrPopupInEstimate";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "@Services/constants";
import EstimationDetails from "./EstimationDetails";
import {
  DSR_LEVEL_MEASUREMENT_UNIT,
  ESTIMATE_LEVEL_MEASUREMENT_UNIT,
  changeItemTypeInEstimate,
  insertCostDatabaseItem,
  updateCostDatabaseItem,
  deleteCostDatabaseItems,
  getEstimateItemsRemoteData,
  itemListSources,
  saveItemDetails,
  saveItemInEstimate,
  updatedEstimateItemSerial,
  getEstimateTotal,
  getEstimateNumberValueBasedOnSettings,
  getPurchaseUnits,
  isEstimateRequiredPermission,
} from "@Actions/estimation";

import EstimationFooter from "./EstimationFooter";
import AdditionalCostsList from "./AdditionalCostsList";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import IncorrectlyPlacedItemsModal from "./IncorrectlyPlacedItemsModal";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import NumericTextBoxComponent from "@CubeComponents/Mui_Form/NumericTextBoxComponent";
import IconComponent from "@CubeComponents/icons";
import ExcelJS from "exceljs";
import _ from "lodash";

import BoqItemEditPopUp from "./BoqItemEditPopUp";
import BoqItemQuantityChip from "./BoqItemQuantityChip";
import { getGridColumns1, getRemoteDataServices, getStaticDataSource, gridTools1, BOQToolsIdsMap } from "./BoqHelper1";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { v4 as uuid } from "uuid";
import Text from "@CubeComponents/html/Text/Text";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import ProviderApp from "../../../../ProviderApp";
import { axiosWrapper } from "@Services/axiosWrapper";
import {
  ADDON_CODE_TO_LAYOUT_FLAG,
  ADDONS_DISPLAY_NAME,
  folderPermissions,
  RATE_ANALYSIS_ADDON_CODE,
} from "@Helpers/constants";
import { getTotal } from "@Features/commercial-shared";
import { excelImportSources } from "@Components/ExcelImport/ExcelHelper";
import ToggleSwitchComponent from "@CubeComponents/form/ToggleSwitchComponent";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { getSymbolForNumber } from "@Services/utils/helpers";
import { getEstimateData } from "@Actions/EstimateList";
import { showToastNotification } from "@Reducers/toastSlice";
import ExcelImport from "@Components/ExcelImport/ExcelImport";
import SlickGrid, {
  type ValidatedColumnDefinition,
  type QueryShape,
  type SlickgridReactInstanceX,
} from "@CubeComponents/html/SlickGrid1";
import { type Formatter, Formatter as SlickFormatter } from "slickgrid-react";
import SelectDropDown, { type SelectEventArgs } from "@CubeComponents/Mui_Form/SelectDropDown";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import { Box } from "@mui/material";
import useLayoutModuleAccess from "@Services/useLayoutModuleAccess";
import { sanitizeCsvRow } from "@Utils/sanitize";
import {
  SaveEstimateItemValueSchema,
  type EstimateData,
  type EstimateCurrency,
} from "@ServerTypes/estimates/estimates.schema";
import type { EstimateItemRateAnalysis } from "@ServerTypes/estimates/estimates.collection";
import type { GetPurchaseUnitsResponse } from "@ServerTypes/units/units.schema";
import type { InsertDsrItemRequest, UpdateDsrItemRequest } from "@ServerTypes/dsr/dsr.schema";
import { EXPORT_TYPE, exportPdf } from "@Services/fileDownload";
import type { RootState } from "@Reducers/index";
import {
  buildChildMap,
  getAllChildrenOptimized,
} from "@Features/contracts/components/Contracts/ContractDetails/helper";

type PurchaseUnitItem = NonNullable<GetPurchaseUnitsResponse["result"]>[number];

const RateAnalysis = lazy(() => import("./RateAnalysis"));
const { RESOURCE_MODIFY, RESOURCE_DOWNLOAD } = folderPermissions();

type RateAnalysisPayload = EstimateItemRateAnalysis;

type EstimateItem = {
  itemId: string;
  parentId?: null | string;
  expanded?: boolean;
  hasChild?: boolean;
  _id?: string;
  code?: string | null;
  description?: string;
  parentItem?: { code?: string; description?: string };
  purchaseUnit?: { id?: string; name?: string };
  purchaseUnitsId?: string;
  rate?: number | null;
  quantity?: number | null;
  amount?: number;
  manualQuantity?: number | null;
  serial?: number;
  level?: number;
  itemLevel?: number;
  targetLevel?: number;
  fromIndex?: number;
  dropIndex?: number;
  currentItemId?: string;
  type?: string;
  uniqueId?: string;
  HSN_SAC?: string;
  isChildFetched?: boolean;
  hasChildRecords?: boolean;
  isAlreadyAddedInThisContract?: boolean;
  isAlreadyLinkedWithThisWBSItem?: boolean;
  isAlreadyAddedInThisTask?: boolean;
  isAlreadyAddedInThisForm?: boolean;
  isDefault?: boolean;
  inspectionId?: string;
  progressUpdateId?: string;
  quantityUsedInThisContract?: number;
  availableQuantity?: number;
  quantityInForm?: number;
  totalUsedQuantity?: number;
  revisedQuantity?: number;
  additionalAmount?: number;
  totalAmount?: number;
  linkedAmount?: number;
  remainingAmount?: number;
  children?: EstimateItem[];
  enableItemColor?: boolean;
  __isDummy?: boolean;
  __hasChildren?: boolean;
  __collapsed?: boolean;
  isExpanded?: boolean;
  id?: string;
  position?: number;
  action?: string;
  treeLevel?: number;
  disableSelection?: boolean;
  allowSelection?: boolean;
  parent?: number | string;
  rateAnalysis?: RateAnalysisPayload | null;
  childRecords?: EstimateItem[];
  sourceFormNo?: string;
  totalQuantity?: number;
  usedQuantity?: number;
  remainingQuantity?: number;
  quantityFromTakeoffs?: number | null;
  parentsList?: Array<{ itemId?: string; parentId?: string; type?: string }>;
};

type EstimateItemRow = EstimateItem & { fullSerial?: string };

type ToolbarButtonId = (typeof BOQToolsIdsMap)[keyof typeof BOQToolsIdsMap];

type ChildParentMapper = { itemId: string; parentId: string };

type ItemListSourceValue = (typeof itemListSources)[keyof typeof itemListSources];

type EstimateDsrItemsProps = {
  // `source` is one of the `itemListSources` values, but is widened to `string`
  // throughout the file because it flows into many `[...].includes(sourceLit)` calls
  // that expect the wider type. Use `ItemListSourceValue` casts at call sites
  // that require the narrow type (e.g. `getGridColumns1`).
  source: string;
  estimateId?: string;
  estimateVersionId?: string;
  dsrId?: string;
  dsrVersionId?: string;
  isStaticData?: boolean;
  queryProp?: Parameters<typeof getRemoteDataServices>[0]["queryProp"];
  itemSelectionCallback?: () => void;
  fetchCostDatabase?: () => void;
  fetchVersionsOfDsr?: () => void;
  currencyData: EstimateCurrency;
  stateToUpdateBoqDatasource?: boolean;
  showGrandTotalFooter?: boolean;
  initialTreeGridRef?: React.MutableRefObject<TreeGridRef | null> | null;
  getCustomBoqQuantity?: (args: {
    itemId: string;
    originalTaskId?: string;
    inspectionId?: string;
    progressUpdateId?: string;
    value: number;
  }) => void;
  handleInfoIconClick?: (args: {
    itemId: string;
    inspectionId?: string;
    progressUpdateId?: string;
    originalTaskId?: string;
  }) => void;
  enableQuantitySelection?: boolean;
  contractId?: string;
  contractVersionId?: string;
  taskLinking?: boolean;
  formLinking?: boolean;
  formId?: string;
  taskId?: string;
  preSelectedItems?: EstimateItem[];
  cssClass?: string;
  setAutoPopulateState?: (checked: boolean) => void;
  showOnlyGrid?: boolean;
  publishedVersion?: boolean;
  setBtnState?: (state: boolean) => void;
  wbsOriginalItemId?: string;
  selectionEvent?: (selectedRecords: EstimateItem[]) => void;
  canEdit?: boolean;
  childParentMapper?: ChildParentMapper;
  showInfoColumn?: boolean;
  handleInfoClick?: (record: EstimateItem) => void;
  showHeaderWithIcon?: boolean;
  enableFilteringOption?: boolean;
  enableSortingOption?: boolean;
  enableColumnChooser?: boolean;
  enableRowResize?: boolean;
  enableWrapOnInitialLoad?: boolean;
  disableMenuOptions?: boolean;
  enableSelectAll?: boolean;
  disableExport?: boolean;
  enableCheckboxSelector?: boolean;
  // When true, the grid renders at its full content height (SlickGrid `autoHeight`) and drops the
  // forced `height:100%` on the container (`disableFullHeight`). Use inside auto-height containers
  // such as an expanded MUI Accordion, where a percentage-height chain collapses to ~0: the grid
  // then shows all rows and the container grows to fit instead of pinning to the min-height floor.
  growToContent?: boolean;
};

// SlickGrid tree data view used by this component. We avoid pulling the full
// slickgrid types here since this file relies on a thin local wrapper.
type TreeGridDataView = {
  getItemMetadata?: (rowIndex: number) => { cssClasses: string } | null;
  getItem: (rowIndex: number) => EstimateItem;
  getAllSelectedItems: () => EstimateItem[];
  items: EstimateItem[];
  setItems: (items: EstimateItem[]) => void;
};

type TreeGridSlick = {
  invalidate: () => void;
  render: () => void;
  getColumns: () => Array<{ id: string; hidden?: boolean; width?: number }>;
  columns: Array<{ id: string }>;
  getSelectedRows: () => number[];
  setSelectedRows: (rows: number[]) => void;
  data: { items: EstimateItem[] };
};

type TreeDataService = {
  dynamicallyToggleItemState: (entries: Array<{ itemId?: string; isCollapsed: boolean }>) => void;
  toggleTreeDataCollapse: (collapse: boolean) => void;
};

type ExternalRegisteredResource = { className: string; exportToExcel: (args: { filename?: string }) => Promise<void> };

type TreeGridRef = {
  dataView: TreeGridDataView;
  slickGrid: TreeGridSlick;
  treeDataService: TreeDataService;
  extensionService: {
    sharedService: {
      externalRegisteredResources: ExternalRegisteredResource[];
    };
  };
  refresh: () => void;
  addRecord: (row: EstimateItem, position?: number) => void;
  removeRecord: (position: number | undefined, row: EstimateItem) => void;
};

type SlickFormatterParams = Parameters<SlickFormatter>;

const EstimateDsrItems = forwardRef<TreeGridRef | null, EstimateDsrItemsProps>((props, ref) => {
  const { t } = useTranslation();
  const {
    source,
    estimateId,
    estimateVersionId,
    dsrId,
    dsrVersionId,
    isStaticData = false,
    queryProp,
    itemSelectionCallback,
    fetchCostDatabase,
    fetchVersionsOfDsr,
    currencyData,
    stateToUpdateBoqDatasource,
    showGrandTotalFooter = true,
    initialTreeGridRef,
    getCustomBoqQuantity,
    handleInfoIconClick,
    enableQuantitySelection = true,
    contractId,
    contractVersionId,
    taskLinking = false,
    formLinking = false,
    formId,
    taskId,
    preSelectedItems = [],
    cssClass,
    setAutoPopulateState,
    showOnlyGrid = false,
    publishedVersion,
    setBtnState,
    wbsOriginalItemId,
    selectionEvent,
    canEdit = true,
    childParentMapper = {
      itemId: "id",
      parentId: "parentId",
    },
    showInfoColumn = false,
    handleInfoClick,
    showHeaderWithIcon = true,
    enableFilteringOption = true,
    enableSortingOption = true,
    enableColumnChooser = true,
    enableRowResize = true,
    enableWrapOnInitialLoad = false,
    disableMenuOptions = false,
    enableSelectAll = true,
    disableExport = false,
    enableCheckboxSelector = true,
    growToContent = false,
  } = props;
  const dispatch = useDispatch();
  const contractDetails = useSelector((state: RootState) => state.contractDetails);

  const costDatabaseState = useSelector((state: RootState) => state.costDatabase);
  const costDatabase = source === itemListSources.COST_DATABASE && costDatabaseState;
  const estimateData = useSelector((state: RootState) => state.estimateData);

  // Narrow alias used for the literal-typed `.includes(source)` checks that need
  // the precise `ItemListSourceValue` union. The runtime value is the same.
  const sourceLit = source as ItemListSourceValue;

  const [openDsrPopup, setOpenDsrPopup] = useState(false);
  const [estimationFooterKey, setEstimationFooterKey] = useState(1);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [showAdditionalCosts, setShowAdditionalCosts] = useState(false);
  const [dsrPopupParent, setDsrPopupParent] = useState({
    parentId: "0",
    level: -1,
  });
  // `items.purchaseUnit` is the write-side ObjectId string (not the populated
  // `{ id, name }` object), because these objects come from a failed-then-retried
  // insert payload, not from a fetched EstimateItem.
  const [incorrectlyPlacedItems, setIncorrectlyPlacedItems] = useState<{
    show: boolean;
    items: Array<Omit<EstimateItem, "purchaseUnit"> & { purchaseUnit?: string }>;
  }>({
    show: false,
    items: [],
  });
  const [openItemPropertiesSidebar, setOpenItemPropertiesSidebar] = useState<{
    status: boolean;
    data: Partial<EstimateItem>;
  }>({
    status: false,
    data: {},
  });

  const [openModalPopup, setOpenModalPopup] = useState(false);
  const [rateAnalysisItemsData, setRateAnalysisItemsData] = useState<{
    checkedRecord?: {
      code?: string | null;
      description?: string;
      parentId?: string | null;
      purchaseUnit?: EstimateItem["purchaseUnit"];
    };
    parentRecord?: { code?: string | null; description?: string };
  }>({});
  const [openRateAnalysisModal, setOpenRateAnalysisModal] = useState(false);
  const [itemForRateAnalysisData, setItemForRateAnalysisData] = useState<Partial<EstimateItem>>({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [editItem, setEditItem] = useState<{ show: boolean; data: Partial<EstimateItem> }>({
    show: false,
    data: {},
  });
  const [staticDataSource, setStaticDataSource] = useState<EstimateItem[] | undefined>(undefined);
  const [remoteDataSource, setRemoteDataSource] = useState<string | null>(null);
  const [remoteQuery, setRemoteQuery] = useState<ReturnType<typeof getRemoteDataServices>[1] | undefined>(undefined);
  const [toolbar, setToolbar] = useState<ReturnType<typeof gridTools1> | null>(null);
  const [gridColumns, setGridColumns] = useState<ReturnType<typeof getGridColumns1> | null>(null);
  const buttonIntialState = {
    [BOQToolsIdsMap.ADD_TOP]: false,
    [BOQToolsIdsMap.ADD_CHILD]: true,
    [BOQToolsIdsMap.EDIT]: true,
    [BOQToolsIdsMap.DELETE]: true,
    [BOQToolsIdsMap.UPDATE]: true,
    [BOQToolsIdsMap.CANCEL]: true,
    [BOQToolsIdsMap.CHANGE_TYPE]: true,
    [BOQToolsIdsMap.EXPAND_ALL]: false,
    [BOQToolsIdsMap.COLLAPSE_ALL]: false,
    [BOQToolsIdsMap.IMPORT_EXCEL]: true,
    [BOQToolsIdsMap.MODIFY_TOTAL]: false,
    [BOQToolsIdsMap.EXPORT_EXCEL]: false,
    [BOQToolsIdsMap.EXPORT_PDF]: false,
    [BOQToolsIdsMap.PROPERTIES]: true,
  };
  const [toolbarButtonDisableState, setToolbarButtonDisableState] = useState(buttonIntialState);
  // `purchaseUnit` is widened: the inline edit handlers store the write-side
  // ObjectId string (set in the unit AutoComplete `onChange` at the bottom of
  // this file), while reads via Partial<EstimateItem> still see the populated
  // `{ id, name }` object. Both shapes coexist in this editing buffer.
  const [editingRowValue, setEditingRowValue] = useState<
    Partial<Omit<EstimateItem, "purchaseUnit">> & {
      manualQuantity?: number | string | null;
      rate?: number | string | null;
      quantity?: number | string | null;
      purchaseUnit?: EstimateItem["purchaseUnit"] | string | null;
    }
  >({});
  const [isWrapTextActive, setIsWrapTextActive] = useState(enableWrapOnInitialLoad);
  const [showGridLoader, setShowGridLoader] = useState(false);
  const [isGridReady, setIsGridReady] = useState(false);

  const innerRef = useRef<TreeGridRef | null>(null);
  const treeGridRef = (initialTreeGridRef || ref || innerRef) as React.MutableRefObject<TreeGridRef>;
  const estimateDataRef = useRef<EstimateData>({ ...estimateData });
  const editingRowValueRef = useRef<
    Partial<Omit<EstimateItem, "purchaseUnit">> & {
      manualQuantity?: number | string | null;
      rate?: number | string | null;
      quantity?: number | string | null;
      purchaseUnit?: EstimateItem["purchaseUnit"] | string | null;
    }
  >({});
  const quantityVals = useRef<{ [key: string]: number | string }>({});
  const [purchaseUnitsOptions, setPurchaseUnitsOptions] = useState<PurchaseUnitItem[]>([]);

  // The grid renders this component with an `onMouseWheel` prop that is not part
  // of `NumericTextBoxProps` — preserve the original escape hatch with a typed cast.
  const NumericTextBoxComponentAny = NumericTextBoxComponent as React.ComponentType<
    React.ComponentProps<typeof NumericTextBoxComponent> & { onMouseWheel?: (e: React.WheelEvent) => void }
  >;
  const estimateCostDatabaseVersionId = (estimateData.costDatabase as { costDatabaseVersionId?: string } | undefined)
    ?.costDatabaseVersionId;

  const addonsAccess = useLayoutModuleAccess(ADDON_CODE_TO_LAYOUT_FLAG[RATE_ANALYSIS_ADDON_CODE]);
  const parentChildMap = useRef<Record<string, EstimateItem[]>>({});
  useEffect(() => {
    const fetchPurchaseUnits = async () => {
      const response = await getPurchaseUnits({});
      if (response.data?.result) {
        setPurchaseUnitsOptions(response.data.result);
      }
    };
    if (source === itemListSources.ESTIMATE || source === itemListSources.COST_DATABASE) {
      fetchPurchaseUnits();
    }
  }, [source]);

  useEffect(() => {
    editingRowValueRef.current = editingRowValue;
  }, [editingRowValue]);

  useEffect(() => {
    const columns = getGridColumns1({
      source: source as ItemListSourceValue,
      showHeaderWithIcon,
      showInfoColumn,
      costDatabaseCurrencySymbol: currencyData.selectedSymbol.name,
      currencyData,
      detailTemplate: detailTemplate as unknown as Formatter,
      serialTemplate: serialTemplate as unknown as Formatter,
      totalQuantityTemplate: totalQuantityTemplate as unknown as Formatter,
      remainingQuantityTemplate: remainingQuantityTemplate as unknown as Formatter,
      usedQuantityTemplate: usedQuantityTemplate as unknown as Formatter,
      quantityTemplate: quantityTemplate as unknown as Formatter,
      unitTemplate: unitTemplate as unknown as Formatter,
      rateTemplate: rateTemplate as unknown as Formatter,
      amountTemplate: amountTemplate as unknown as Formatter,
      linkedAmountTemplate: linkedAmountTemplate as unknown as Formatter,
      remainingAmountTemplate: remainingAmountTemplate as unknown as Formatter,
      textEditTemplate,
      quantityEditTemplate,
      unitEditTemplate,
      rateEditTemplate,
    });

    // setGridColumns((prev : any)=>{
    //   if(prev){
    //     columns.map(column=>{
    //       column.hidden = prev.find((col:any)=> col.id == column.id)?.hidden
    //     })
    //   }
    //   return columns
    // })
    setGridColumns(columns);
  }, [purchaseUnitsOptions]);

  useEffect(() => {
    if (
      estimateId &&
      // estimateData._id !== estimateId &&
      (source === itemListSources.LINK_BOQ_ITEMS ||
        source === itemListSources.PREVIEW_BOQ_ITEMS ||
        source === itemListSources.ESTIMATE)
    ) {
      dispatch(getEstimateData({ estimateId, versionId: estimateVersionId }));
    }
  }, [estimateId, estimateVersionId, source]);

  const init = async () => {
    setShowGridLoader(true);
    await fetchData({ replaceData: true, getAllItems: true });
    setShowGridLoader(false);
  };

  useEffect(() => {
    if (Array.isArray(preSelectedItems) && source === itemListSources.PREVIEW_BOQ_ITEMS) {
      const childrenMap: Record<string, EstimateItem[]> = {};
      const childMap = buildChildMap(preSelectedItems || []);

      (preSelectedItems || []).forEach((item) => {
        if (item.hasChild) {
          childrenMap[item.itemId] = getAllChildrenOptimized(item.itemId, childMap);
        }
      });
      parentChildMap.current = childrenMap;
      setStaticDataSource(preSelectedItems);
    }
  }, [preSelectedItems, source]);

  useEffect(() => {
    if (source === itemListSources.PREVIEW_BOQ_ITEMS && preSelectedItems) {
      setStaticDataSource(preSelectedItems);
    } else if (isStaticData) {
      init();
    } else {
      const [remoteDataSourceUrl, query] = getRemoteDataServices({
        source: sourceLit,
        estimateId,
        estimateVersionId,
        queryProp,
        dsrId,
        dsrVersionId,
        publishedVersion,
        wbsOriginalItemId,
        contractVersionId,
        contractId,
        taskLinking,
        formLinking,
        formId,
        taskId,
        parentContractId: contractDetails.parentId,
        contractType: contractDetails.basedOnWBS ? "basedOnWBS" : undefined,
      });
      setRemoteDataSource(remoteDataSourceUrl ?? null);
      setRemoteQuery(query);
    }
  }, [estimateId, estimateVersionId]);

  useEffect(() => {
    if (estimateData._id) {
      estimateDataRef.current = { ...estimateData };
    }
  }, [estimateData]);

  const dropDownButtonItems = [
    { text: t("Add New Item"), id: "estimateItem" },
    { text: t("Add Item from Cost Database"), id: "dsrItem", disabled: !_.get(estimateData, "costDatabase.id") },
  ];

  const addTopButtonTemplate = () =>
    source === itemListSources.ESTIMATE ? (
      <div className="">
        <SelectDropDown
          allowButtonPadding={false}
          select={handleAddTopSelectionHandler}
          items={dropDownButtonItems}
          id={BOQToolsIdsMap.ADD_TOP}
        >
          <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
            <span className="inline-block">
              <div className="flex items-center gap-1" data-testid="AddTopButton">
                <IconComponent name="add" className="me-1" width="1rem" height="1rem" />
                <span>{t("Add Top")}</span>
              </div>
            </span>
          </ButtonComponent>
        </SelectDropDown>
      </div>
    ) : (
      <div className="">
        <ButtonComponent
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          id={BOQToolsIdsMap.ADD_TOP}
          onClick={() => toolBarClickHandlerNew(BOQToolsIdsMap.ADD_TOP)}
        >
          <span className="flex items-center gap-1" data-testid="AddTopButton">
            <IconComponent name="add" className="me-1" width="1rem" height="1rem" />
            {t("Add Top")}
          </span>
        </ButtonComponent>
      </div>
    );

  const addChildButtonTemplate = () =>
    source === itemListSources.ESTIMATE ? (
      <div className="">
        <SelectDropDown
          allowButtonPadding={false}
          select={handleAddChildSelectionHandler}
          items={dropDownButtonItems}
          id={BOQToolsIdsMap.ADD_CHILD}
        >
          <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
            <span className="inline-block">
              <div className="flex items-center gap-1" data-testid="AddChildButton">
                <IconComponent name="add" className="me-1" width="1rem" height="1rem" />
                <span>{t("Add Child")}</span>
              </div>
            </span>
          </ButtonComponent>
        </SelectDropDown>
      </div>
    ) : (
      <div className="">
        <ButtonComponent
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          id={BOQToolsIdsMap.ADD_CHILD}
          onClick={() => toolBarClickHandlerNew(BOQToolsIdsMap.ADD_CHILD)}
        >
          <span className="flex items-center gap-1" data-testid="AddChildButton">
            <IconComponent name="add" className="me-1" width="1rem" height="1rem" />
            {t("Add Child")}
          </span>
        </ButtonComponent>
      </div>
    );

  const propertiesBtnTemplate = () => (
    <div className="ms-4 me-4" id={BOQToolsIdsMap.PROPERTIES} data-testid="itemPropertiesButton">
      <IconComponent
        name="properties"
        onClick={() => toolBarClickHandlerNew(BOQToolsIdsMap.PROPERTIES)}
        width="1.25rem"
        height="1.25rem"
      />
    </div>
  );

  const canModify = isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id);
  const canDownload = isEstimateRequiredPermission(estimateData, RESOURCE_DOWNLOAD.id);

  useEffect(() => {
    if (estimateData._id && source === itemListSources.ESTIMATE) {
      setToolbarButtonDisableState((prev) => ({
        ...prev,
        [BOQToolsIdsMap.ADD_TOP]: !canModify,
        [BOQToolsIdsMap.MODIFY_TOTAL]: !canModify,
        [BOQToolsIdsMap.EXPORT_EXCEL]: !canDownload,
        [BOQToolsIdsMap.EXPORT_PDF]: !canDownload,
        [BOQToolsIdsMap.IMPORT_EXCEL]: !canModify,
      }));
    }
  }, [estimateData._id, canModify, canDownload, source]);

  useEffect(() => {
    if (
      (!showOnlyGrid &&
        source !== itemListSources.ESTIMATE &&
        source !== itemListSources.BOQ_PRINT &&
        source !== itemListSources.LINK_BOQ_ITEMS &&
        source !== itemListSources.PREVIEW_BOQ_ITEMS &&
        source !== itemListSources.ESTIMATE_ATTACHED_CD_PREVIEW) ||
      estimateData._id
    ) {
      const tools = gridTools1({
        source: sourceLit,
        canEdit,
        dsrVersionId,
        estimateVersionId,
        toolbarButtonDisableState,
        addTopButtonTemplate,
        addChildButtonTemplate,
        propertiesBtnTemplate,
        toggleTemplate,
        formLinking,
        disableExport,
      });
      setToolbar(tools);
    }
  }, [estimateData._id, toolbarButtonDisableState]);

  useEffect(() => {
    if (
      (source === itemListSources.ADD_ITEM_POPUP ||
        source === itemListSources.LINK_BOQ_ITEMS ||
        source === itemListSources.PREVIEW_BOQ_ITEMS ||
        source === itemListSources.CONTRACT_CDB) &&
      treeGridRef.current?.dataView
    ) {
      const dv = treeGridRef.current.dataView;
      dv.getItemMetadata = (rowIndex: number) => {
        const item = dv.getItem(rowIndex);
        if (item.enableItemColor == false) {
          return {
            cssClasses: "slick-disable-tree-row",
          };
        }
        if (
          item.isAlreadyAddedInThisContract ||
          item.isAlreadyLinkedWithThisWBSItem ||
          item.isAlreadyAddedInThisTask ||
          item.isAlreadyAddedInThisForm
        ) {
          return {
            cssClasses: "slick-disable-tree-row",
          };
        }

        return null;
      };
      treeGridRef.current.slickGrid.invalidate();
      treeGridRef.current.slickGrid.render();
    }
  }, [treeGridRef.current, isGridReady, staticDataSource, source]);

  const fetchData = async ({
    parentId,
    addData,
    replaceData,
    isChildFetched,
    isReturnData,
    getAllItems = false,
  }: {
    parentId?: string;
    addData?: boolean;
    replaceData?: boolean;
    isChildFetched?: boolean;
    isReturnData?: boolean;
    getAllItems?: boolean;
  }) => {
    const response = (await getStaticDataSource({
      source: sourceLit,
      parentId,
      estimateId,
      estimateVersionId,
      dsrId,
      dsrVersionId,
      publishedVersion,
      getAllItems,
      queryProp: queryProp as Parameters<typeof getStaticDataSource>[0]["queryProp"],
    })) as EstimateItem[];

    let itemsData: EstimateItem[] = staticDataSource ? _.cloneDeep(staticDataSource) : [];
    if (isChildFetched) {
      itemsData = itemsData.map((item: EstimateItem) => {
        if (item.itemId === parentId) {
          return {
            ...item,
            isChildFetched: true,
            hasChild: true,
            isExpanded: true,
          };
        }
        return item;
      });
    }
    if (addData) {
      const needToAddData = response.filter(
        (item: EstimateItem) => !itemsData.some((itemData: EstimateItem) => itemData.itemId == item.itemId),
      );
      itemsData = [...itemsData, ...needToAddData];
    } else if (replaceData) {
      if (
        (source == itemListSources.COST_DATABASE && !dsrVersionId) ||
        (source === itemListSources.ESTIMATE && !estimateVersionId)
      ) {
        setToolbarButtonDisableState((prev) => ({
          ...prev,
          [BOQToolsIdsMap.IMPORT_EXCEL]: !(
            (source == itemListSources.COST_DATABASE ||
              isEstimateRequiredPermission(estimateDataRef.current, RESOURCE_MODIFY.id)) &&
            !response.length
          ),
        }));
      }
      itemsData = response;
    }

    if (!isReturnData) {
      setStaticDataSource(itemsData);
    }
    return itemsData;
  };

  function handleImportExcel() {
    if (!staticDataSource!.length) {
      setShowFileUploadModal(true);
    }
  }

  function changeEstimateFooterKey() {
    setEstimationFooterKey((prev) => (prev == 1 ? 0 : 1));
  }

  function closeDsrPopup() {
    setOpenDsrPopup(false);
    setDsrPopupParent({ parentId: "0", level: -1 });
  }

  function handleDiscardItemAdditionFromPopup() {
    closeDsrPopup();
  }

  function closeIncorrectPlacedItemsModal() {
    setIncorrectlyPlacedItems({ show: false, items: [] });
  }

  async function saveItemsWithCorrectPlacement() {
    const { items } = incorrectlyPlacedItems;

    for (let i = 0; i < items.length; i++) {
      const itemParams = items[i]!;
      delete itemParams.purchaseUnit;

      const payload = {
        action: "insert" as const,
        params: { estimateId, forceCorrectItemPlacement: true },
        value: itemParams as SaveEstimateItemValueSchema,
      };

      const res = await saveItemInEstimate(payload);
      if (res.data.status && res.data.result?.length) {
        for (const item of res.data.result) {
          updateItemsListData({ action: payload.action, data: item as EstimateItem });
        }
      }
    }

    closeIncorrectPlacedItemsModal();
    refreshDataGrid();
  }

  async function addMultipleItemsToBoq(items: EstimateItem[]) {
    // The values pushed here keep `purchaseUnit` as the ObjectId string (write-side
    // shape), distinct from `EstimateItem.purchaseUnit` which is the populated
    // `{ id, name }` object (read-side shape). The local array is widened to allow
    // both so the items can later be re-submitted in `saveItemsWithCorrectPlacement`.
    const incorrectItemPlacedObjs: Array<Omit<EstimateItem, "purchaseUnit"> & { purchaseUnit?: string }> = [];
    let currentStateDataForMultipleOps = _.cloneDeep(staticDataSource);
    for (let i = 0; i < items.length; i++) {
      const item = items[i]!;

      const { purchaseUnit, rate, description, itemId, code, targetLevel: level, parentId } = item;

      const payload = {
        action: "insert" as const,
        params: { estimateId },
        value: {
          purchaseUnit: purchaseUnit?.id,
          rate,
          description,
          itemId,
          code,
          level,
          quantity: 0,
          parentId,
        },
      };

      const res = await saveItemInEstimate(payload);

      if (!res.data.status && res.data.errorMessage === "Please add the item under its dsr parent item hierarchy") {
        incorrectItemPlacedObjs.push({
          purchaseUnit: purchaseUnit?.id,
          rate,
          description,
          itemId: itemId as string,
          code,
          level,
          quantity: 0,
          parentId,
        });
      } else if (res.data.result?.length) {
        for (const item of res.data.result) {
          currentStateDataForMultipleOps = await updateItemsListData({
            action: payload.action,
            data: item as EstimateItem,
            currentStateDataForMultipleOps,
          });
        }
      }
    }
    if (incorrectItemPlacedObjs.length !== items.length) {
      setStaticDataSource(currentStateDataForMultipleOps);
    }

    if (!incorrectItemPlacedObjs.length) {
      dispatch(
        showToastNotification({
          content: t("The items have been added"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      return;
    }

    setIncorrectlyPlacedItems({ show: true, items: incorrectItemPlacedObjs });
  }

  async function handleItemAdditionFromPopup(items: EstimateItem[]) {
    setButtonLoading(true);
    await addMultipleItemsToBoq(items);

    setButtonLoading(false);
    closeDsrPopup();
  }

  const generateRateAnalysisFields = (record: EstimateItem) => {
    const obj: {
      checkedRecord: {
        code?: string | null;
        description?: string;
        parentId?: string | null;
        purchaseUnit?: EstimateItem["purchaseUnit"];
      };
      parentRecord?: { code?: string | null; description?: string };
    } = {
      checkedRecord: {
        code: record.code,
        description: record.description,
        parentId: record.parentId,
        purchaseUnit: record.purchaseUnit,
      },
    };
    if (record.parentId) {
      const parentItemData = treeGridRef.current.dataView.items.find(
        (item: EstimateItem) => item.itemId == record.parentId,
      ) as EstimateItem;
      obj.parentRecord = {
        code: parentItemData.code,
        description: parentItemData.description,
      };
    }
    setRateAnalysisItemsData(obj);
  };

  function openSidebar(record: EstimateItem) {
    if (!record.itemId) {
      return;
    }
    generateRateAnalysisFields(record);
    setOpenItemPropertiesSidebar({
      status: true,
      data: { ...record, manualQuantity: record.quantity },
    });
  }

  function closeSidebar() {
    setOpenItemPropertiesSidebar({ status: false, data: {} });
  }

  function refreshDataGrid(getData = false) {
    if (isStaticData && staticDataSource && getData) {
      init();
    } else if (remoteDataSource) {
      treeGridRef.current.refresh();
    }
    if (source === itemListSources.ESTIMATE) {
      setEstimationFooterKey((prev) => (prev == 1 ? 0 : 1));
    }
  }

  function closeAdditionalCostModal() {
    setShowAdditionalCosts(false);
  }

  function popupTreeGridSelectionEvent() {
    const selectedData = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);

    if (setBtnState) {
      if (selectedData.length > 0) {
        let btnState = true;
        selectedData.map((item: EstimateItem) => {
          if (
            item.isAlreadyAddedInThisContract ||
            item.isAlreadyLinkedWithThisWBSItem ||
            item.isAlreadyAddedInThisTask ||
            item.isAlreadyAddedInThisForm
          ) {
            btnState = false;
          }
        });
        setBtnState(btnState);
      } else {
        setBtnState(false);
      }
    }
    if (source === itemListSources.ADD_ITEM_POPUP && itemSelectionCallback) {
      itemSelectionCallback();
      return;
    }
    //   if (name === 'rowSelected' && setBoqItemsToLink && (source === itemListSources.LINK_BOQ_ITEMS) && params.isInteracted) {
    //     if (Array.isArray(data)) {
    //         setBoqItemsToLink((prev) => [...prev, ...data]);
    //     }
    //     else {
    //         setBoqItemsToLink((prev) => [...prev, data]);
    //     }
    // }
    // if (params.name === 'rowDeselected' && setBoqItemsToLink && (source === itemListSources.LINK_BOQ_ITEMS) && params.isInteracted) {
    //     if (Array.isArray(data)) {
    //         const itemId = data.map((item) => item._id);
    //         setBoqItemsToLink((prev) => prev.filter((item) => !itemId.includes(item._id)));
    //     }
    //     else {
    //         setBoqItemsToLink((prev) => prev.filter((item) => item._id != data._id));
    //     }
    // }

    // if(source === itemListSources.PREVIEW_BOQ_ITEMS && selectedData.length==0 && !data.isDefault){
    //   tree?.toolbarModule?.enableItems(['custom_remove'],false)
    // }
    // if(source === itemListSources.PREVIEW_BOQ_ITEMS && selectedData.length>0 && !data.isDefault){
    //   tree?.toolbarModule?.enableItems(['custom_remove'],true)
    // }
  }

  function sortTreeGridSource(data: EstimateItem[]) {
    const customSort = (a: EstimateItem, b: EstimateItem) => {
      if (String(a.parentId ?? "") === "0" && String(b.parentId ?? "") !== "0") {
        return -1;
      }
      if (String(a.parentId ?? "") !== "0" && String(b.parentId ?? "") === "0") {
        return 1;
      }

      return (a.serial ?? 0) - (b.serial ?? 0);
    };

    return data.sort(customSort);
  }

  async function updateItemsListData({
    action,
    data: dataIn,
    performCommonAction = true,
    currentStateDataForMultipleOps,
  }: {
    action: "insert" | "update" | "delete" | "reorder" | "changeType";
    // A handful of call sites pass `response.data.result` (the server result
    // wrapper) instead of a single item — the response schema models result as
    // an array of looseObject entries. The function body below treats `data`
    // as a single item (reads `data.parentId`, `data.itemId`, etc.). Accept
    // both shapes (and undefined from the optional schema field) so call
    // sites compile without changing the runtime contract.
    data: EstimateItem | Array<{ itemId?: string; [k: string]: unknown }> | undefined;
    performCommonAction?: boolean;
    currentStateDataForMultipleOps?: EstimateItem[];
  }): Promise<EstimateItem[] | undefined> {
    // The looseObject array shape from the response schema is treated as a
    // single EstimateItem at every call site here — preserve that behaviour.
    const data = dataIn as EstimateItem;
    let stateData: EstimateItem[] = currentStateDataForMultipleOps || _.cloneDeep(staticDataSource ?? []);
    let needToChangeRecord = true;

    if (action === "insert" && data.parentId && data.parentId != "0") {
      const parentData = stateData.find((item: EstimateItem) => item.itemId == data.parentId);
      if (!parentData) {
        refreshDataGrid(true);
        return;
      }
      if (parentData.hasChildRecords && !parentData.isChildFetched) {
        stateData = await fetchData({
          parentId: data.parentId,
          addData: true,
          isChildFetched: true,
          isReturnData: true,
        });
        needToChangeRecord = false;
      }
    }

    if (action == "insert") {
      if (data.parentId) {
        const allParentIds = new Set(data.parentsList?.map((parentItem) => parentItem.itemId));
        stateData.map((item: EstimateItem) => {
          if (item.itemId == data.parentId) {
            item.hasChild = true;
            item.__hasChildren = true;
            item.__collapsed = false;
            item.isExpanded = true;
          } else if (allParentIds.has(item.itemId)) {
            item.__collapsed = false;
            item.isExpanded = true;
          }
        });
      }
      if (source === itemListSources.ESTIMATE) {
        let changedAmount = data.amount as number;
        if (data.parentId) {
          stateData.map((estimateItem: EstimateItem) => {
            if (estimateItem.itemId == data.parentId) {
              if (estimateItem.manualQuantity && estimateItem.rate) {
                changedAmount = changedAmount - estimateItem.manualQuantity * estimateItem.rate;
                estimateItem.manualQuantity = null;
              }
              estimateItem.amount = (estimateItem.amount as number) + changedAmount;
            }
          });
        }

        stateData.map((estimateItem: EstimateItem) => {
          if (
            estimateItem.itemId != data.parentId &&
            (data.parentsList as NonNullable<EstimateItem["parentsList"]>).find(
              (parentItem) => parentItem.itemId === estimateItem.itemId,
            )
          ) {
            estimateItem.amount = (estimateItem.amount as number) + changedAmount;
          }
        });
      }

      needToChangeRecord && stateData.push(data);
    } else if (action == "update") {
      let updatedItemPrevData: EstimateItem | undefined;
      stateData = stateData.map((item: EstimateItem) => {
        if (item.itemId === data.itemId) {
          updatedItemPrevData = item;
          return { ...item, ...data };
        }
        return item;
      });

      if (source === itemListSources.ESTIMATE) {
        const prev = updatedItemPrevData as EstimateItem;
        let quantityChanged = prev.additionalAmount
          ? prev.additionalAmount - (data.additionalAmount ? data.additionalAmount : 0)
          : -(data.additionalAmount ? data.additionalAmount : 0);
        if (!data.hasChild) {
          quantityChanged += (prev.amount as number) - (data.amount as number);
        }

        stateData.map((estimateItem: EstimateItem) => {
          if (
            (data.parentsList as NonNullable<EstimateItem["parentsList"]>).find(
              (parentItem) => parentItem.itemId === estimateItem.itemId,
            )
          ) {
            estimateItem.amount = (estimateItem.amount as number) - quantityChanged;
          }
        });
      }
    } else if (action == "delete") {
      if (source === itemListSources.ESTIMATE) {
        const quantityChanged = (data.amount as number) + (data.additionalAmount || 0);
        stateData.map((estimateItem: EstimateItem) => {
          if (
            (data.parentsList as NonNullable<EstimateItem["parentsList"]>).find(
              (parentItem) => parentItem.itemId === estimateItem.itemId,
            )
          ) {
            estimateItem.amount = (estimateItem.amount as number) - quantityChanged;
          }
          if (estimateItem.parentId == data.parentId && (estimateItem.serial as number) > (data.serial as number)) {
            estimateItem.serial = (estimateItem.serial as number) - 1;
          }
        });
      }
      stateData = stateData.filter(
        (estimateItem: EstimateItem) =>
          !(
            estimateItem.itemId == data.itemId ||
            (estimateItem.parentsList as NonNullable<EstimateItem["parentsList"]>).find(
              (parentItem) => parentItem.itemId == data.itemId,
            )
          ),
      );

      if (data.parentId && data.parentId !== "0") {
        stateData.map((estimateItem: EstimateItem) => {
          if (
            estimateItem.itemId == data.parentId &&
            !stateData.find((item: EstimateItem) => item.parentId == data.parentId)
          ) {
            estimateItem.hasChildRecords = false;
            estimateItem.hasChild = false;
          }
        });
      }
    } else if (action === "reorder") {
      const { dropIndex, fromIndex } = data;
      let minValue: number;
      let maxValue: number;
      let updateCount = 1;

      if ((fromIndex as number) > (dropIndex as number)) {
        minValue = dropIndex as number;
        maxValue = (fromIndex as number) + 1;
      } else {
        minValue = (fromIndex as number) + 1;
        maxValue = (dropIndex as number) + 2;
        updateCount = -1;
      }
      stateData.map((itemData: EstimateItem) => {
        if (
          itemData.parentId == data.parentId &&
          (itemData.serial as number) > minValue &&
          (itemData.serial as number) < maxValue
        ) {
          itemData.serial = (itemData.serial as number) + updateCount;
        }
        if (itemData.itemId === data.itemId) {
          itemData.serial = (data.dropIndex as number) + 1;
        }
      });

      stateData = sortTreeGridSource(stateData);
    } else if (action === "changeType") {
      stateData.map((item: EstimateItem) => {
        if (item.itemId == data.itemId) {
          item.code = null;
          item.type = "ESTIMATE";
          item.itemId = data.currentItemId as string;
        }
        if (item.parentId == data.itemId) {
          item.parentId = data.currentItemId;
        }
        if (item.parentsList?.find((parentItem) => parentItem.itemId === data.itemId)) {
          item.parentsList = item.parentsList.map((itemParentData) => {
            if (itemParentData.itemId == data.itemId) {
              itemParentData.itemId = data.currentItemId;
              itemParentData.type = "ESTIMATE";
            }
            return itemParentData;
          });
        }
      });
    }

    if (currentStateDataForMultipleOps) {
      currentStateDataForMultipleOps = stateData;
    } else {
      setStaticDataSource(stateData);
    }
    if (performCommonAction) {
      setToolbarButtonDisableState((prev) => ({
        ...prev,
        ...buttonIntialState,
        [BOQToolsIdsMap.IMPORT_EXCEL]: true,
      }));
      actionCompleteHandler();
    }
    return stateData;
  }

  function validationForAddItemInEstimate({
    quantity,
    itemId,
    description,
    purchaseUnit,
    rate,
  }: {
    quantity: number | null;
    itemId?: string;
    description?: string;
    purchaseUnit?: string | null;
    rate: number | null;
  }) {
    let content;

    if ((quantity as number) < 0) {
      content = "Please enter a positive value for the quantity";
      return { status: false, content };
    }

    if (quantity && (!purchaseUnit || rate === null)) {
      content = "Please specify the unit and rate for the item";
      return { status: false, content };
    }

    if (!itemId && purchaseUnit && rate === null) {
      content = "Please enter the value of rate";
      return { status: false, content };
    }

    if (!itemId && !purchaseUnit && rate) {
      content = "Please enter the value of unit";
      return { status: false, content };
    }

    if (!itemId && !description) {
      content = "Please enter the description for the item";
      return { status: false, content };
    }

    if (!itemId && rate! < 0) {
      content = "Please enter a positive value for rate";
      return { status: false, content };
    }

    return { status: true };
  }

  async function addRecordInEstimate() {
    const { purchaseUnit, description, HSN_SAC } = editingRowValue;

    const quantity =
      editingRowValue.manualQuantity === null ? null : parseFloat(String(editingRowValue.manualQuantity));
    const rate = editingRowValue.rate ? parseFloat(String(editingRowValue.rate)) : (editingRowValue.rate as null);

    const validationCheck = validationForAddItemInEstimate({
      quantity,
      description,
      // At this call site `purchaseUnit` is always the write-side ObjectId
      // string (set in the inline unit editor below); the editing buffer's
      // union type widens it for typing only.
      purchaseUnit: purchaseUnit as string | null | undefined,
      rate,
    });

    if (!validationCheck.status) {
      const { content } = validationCheck;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_WARNING }));
      setToolbarButtonDisableState((prev) => ({
        ...prev,
        [BOQToolsIdsMap.UPDATE]: false,
        [BOQToolsIdsMap.CANCEL]: false,
      }));
      return;
    }

    const parentId = editingRowValue.parentId ?? "0";
    const level = editingRowValue.itemLevel;

    const payload = {
      level,
      parentId,
      quantity,
      // Same as the validation call above — write-side is ObjectId string only.
      purchaseUnit: purchaseUnit as string | null | undefined,
      rate,
      description,
      HSN_SAC,
    };

    const payloadData = {
      params: { estimateId },
      action: "insert" as const,
      value: payload,
    };

    const response = await saveItemInEstimate(payloadData);
    if (response.data.status) {
      updateItemsListData({
        action: payloadData.action,
        // Service returns the saved item(s); the existing UI flow has always
        // passed the result wrapper through `data` — the function accepts
        // both single-item and array shapes for backwards compatibility.
        data: response.data.result,
      });
    }
    setEditingRowValue({});
  }

  function validationForEditItemInEstimate({
    code,
    description,
    purchaseUnit,
    quantity,
    rate,
  }: {
    code?: string | null;
    description?: string;
    purchaseUnit?: string | null;
    quantity?: number | null;
    rate?: number | null;
  }) {
    let content;

    if (rate! < 0) {
      content = t("Please enter a non negative value for rate");
      return { status: false, content };
    }

    if (quantity! < 0) {
      content = t("Please enter a non negative value for quantity");
      return { status: false, content };
    }

    if (!code && !purchaseUnit && rate) {
      content = t("Please enter a purchase unit");
      return { status: false, content };
    }

    if (!code && purchaseUnit && rate === null) {
      content = t("Please enter a positive value for rate");
      return { status: false, content };
    }

    if (!code && !purchaseUnit && rate === null && quantity) {
      content = t("Please enter the unit and rate for the item");
      return { status: false, content };
    }

    if (!code && !description) {
      content = t("Please enter the description for the item");
      return { status: false, content };
    }

    return { status: true };
  }

  async function editRecordInEstimate() {
    const { itemId, description, purchaseUnit, code, rateAnalysis, HSN_SAC } = editingRowValue;

    const quantity = editingRowValue.quantity === null ? null : parseFloat(String(editingRowValue.quantity));
    const rate = editingRowValue.rate === null ? null : parseFloat(String(editingRowValue.rate));

    const payload: SaveEstimateItemValueSchema = {
      itemId,
      description,
      // Write-side is ObjectId string only (same as addRecordInEstimate above).
      purchaseUnit: purchaseUnit as string | null | undefined,
      quantity,
      rate,
      HSN_SAC,
    };

    if (rateAnalysis) {
      const analysisData = rateAnalysis;
      analysisData.rateAnalysisData.say = rate || 0;
      payload.rateAnalysis = analysisData;
    }

    const validationCheck = validationForEditItemInEstimate({
      code,
      description: payload.description,
      purchaseUnit: payload.purchaseUnit as string | null | undefined,
      quantity: payload.quantity,
      rate: payload.rate,
    });

    if (!validationCheck.status) {
      updateToolbarButtonsOnCancel();
      const { content } = validationCheck;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_WARNING }));
      return;
    }

    const payloadData = {
      params: { estimateId },
      action: "update" as const,
      value: payload as SaveEstimateItemValueSchema,
    };

    const response = await saveItemInEstimate(payloadData);
    if (response.data.status) {
      updateItemsListData({ action: "update", data: response.data.result });
    }
  }

  function validationForAddItemInCostDatabase({
    code,
    description,
    rate,
  }: {
    code?: string | null;
    description?: string;
    rate?: number | null;
  }) {
    let content;

    if (!code || !description) {
      content = "Please enter the code and description for the item";
      return { status: false, content };
    }

    if (rate && rate < 0) {
      content = "Please enter a non negative value for rate";
      return { status: false, content };
    }

    return { status: true };
  }

  async function addRecordInCostDatabase() {
    const { code, description, HSN_SAC, purchaseUnit } = editingRowValue;
    const rate = parseFloat(String(editingRowValue.rate));

    const validationCheck = validationForAddItemInCostDatabase({
      code,
      description,
      rate,
    });

    if (!validationCheck.status) {
      updateToolbarButtonsOnCancel();
      const { content } = validationCheck;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_WARNING }));
      return;
    }

    const parentId = editingRowValue.parentId ?? "0";
    const level = editingRowValue.itemLevel;

    const payload: InsertDsrItemRequest = {
      value: {
        level,
        parentId,
        rate,
        code,
        description,
        // The DSR insert payload accepts `purchaseUnit` as the ObjectId string;
        // editingRowValue widens to allow either shape.
        purchaseUnit: purchaseUnit as string | null | undefined,
        HSN_SAC,
      },
      params: { dsrId },
    };

    const response = await insertCostDatabaseItem(payload);
    if (response.data.status) {
      updateItemsListData({ action: "insert", data: response.data.result });
      setEditingRowValue({});
    } else {
      setUpdateCancelButtonActiveState(false);
      const content = untranslated(response.data.errorMessage) || SOMETHING_WENT_WRONG;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }));
    }
  }

  async function editRecordInCostDatabase() {
    const { itemId, code, description, purchaseUnit, rateAnalysis, HSN_SAC } = editingRowValue;

    const rate = parseFloat(String(editingRowValue.rate));

    const validationCheck = validationForAddItemInCostDatabase({
      code,
      description,
      rate,
    });

    if (!validationCheck.status) {
      const { content } = validationCheck;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_WARNING }));
      setUpdateCancelButtonActiveState(false);
      return;
    }

    const payload: UpdateDsrItemRequest = {
      value: {
        itemId,
        code,
        rate,
        description,
        // editingRowValue.purchaseUnit may be the ObjectId string (inline
        // editor) or the populated `{ id, name }` object (read path).
        purchaseUnit: purchaseUnit as string | null | undefined,
        HSN_SAC,
      },
      params: { dsrId },
    };

    if (rateAnalysis) {
      const analysisData = rateAnalysis;
      analysisData.rateAnalysisData.say = rate || 0;
      payload.value!.rateAnalysis = analysisData;
    }

    const response = await updateCostDatabaseItem(payload);
    if (response.data.status) {
      updateItemsListData({ action: "update", data: response.data.result });
      setEditingRowValue({});
    } else {
      setUpdateCancelButtonActiveState(false);
      const content = untranslated(response.data.errorMessage) || SOMETHING_WENT_WRONG;
      dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }));
    }
  }

  async function handleTypeChange() {
    const selectedRecord = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);
    setToolbarButtonDisableState((prev) => ({ ...prev, [BOQToolsIdsMap.CHANGE_TYPE]: true }));
    if (selectedRecord.length == 1) {
      const response = await changeItemTypeInEstimate({
        itemId: selectedRecord[0]!.itemId,
        estimateId: estimateId!,
      });
      if (response.data.status && response.data.data) {
        updateItemsListData({
          action: "changeType",
          data: {
            itemId: selectedRecord[0]!.itemId,
            currentItemId: response.data.data.currentItemId,
          } as EstimateItem,
        });
      } else {
        setToolbarButtonDisableState((prev) => ({ ...prev, [BOQToolsIdsMap.CHANGE_TYPE]: false }));
        response.data.errorMessage && showToastData(untranslated(response.data.errorMessage));
      }
    }
  }

  const getSerial = (data: EstimateItem[], itemId: string | undefined): string => {
    const findData = data.find((e: EstimateItem) => e.itemId == itemId) as EstimateItem;

    if (!findData.parentId || findData.parentId == "0") {
      return `${findData.serial}`;
    }

    return `${getSerial(data, findData.parentId)}.${findData.serial}`;
  };

  const dottedNumericSort = (
    a: EstimateItemRow | Array<string | number | undefined | null>,
    b: EstimateItemRow | Array<string | number | undefined | null>,
  ) => {
    const firstArg = Array.isArray(a) ? a[0] : a.fullSerial;
    const secondArg = Array.isArray(b) ? b[0] : b.fullSerial;
    const partsA = String(firstArg ?? "")
      .split(".")
      .map(Number);
    const partsB = String(secondArg ?? "")
      .split(".")
      .map(Number);

    for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
      const numA = partsA[i] || 0;
      const numB = partsB[i] || 0;

      if (numA !== numB) {
        return numA - numB;
      }
    }

    return partsA.length - partsB.length;
  };

  async function handleExportPdf() {
    exportPdf({ estimateId, exportType: EXPORT_TYPE.PDF });
  }

  const fetchEstimateTotal = async (data: Parameters<typeof getEstimateTotal>[0]) => {
    const response = await getEstimateTotal(data);
    if (response.data.status) {
      return response.data.data;
    } else {
      return 0;
    }
  };

  const fetchEstimateAdditionalCostTotal = async (data: { estimateId: string; versionId?: string }) => {
    const response = await axiosWrapper.post<{ status?: boolean; data?: number }>(
      `${getBackendUrl()}/estimate/getEstimateAdditionalCostTotal`,
      data,
    );
    if (response.data.status) {
      return response.data.data || 0;
    }
    return 0;
  };

  const handleCostDatabaseExcelExport = async () => {
    const exportService = treeGridRef.current.extensionService.sharedService.externalRegisteredResources.find(
      (service: ExternalRegisteredResource) => service.className === "ExcelExportService",
    );

    const items = treeGridRef.current.dataView.items;
    const elementRowMap: { [itemId: string]: number } = {};
    let rowNo = 2;
    if (exportService && items) {
      treeGridRef.current.dataView.setItems(
        items.map((item: EstimateItem) => {
          if (!item.__isDummy) {
            elementRowMap[item.itemId] = rowNo;
            item.parent = item.parentId ? elementRowMap[item.parentId] : "";
            rowNo++;
          }
          return item;
        }),
      );
    }

    const allColumns = treeGridRef.current.slickGrid.getColumns();
    const parentCol = allColumns?.find((c) => c.id === "parent");
    const originalHidden = parentCol?.hidden;
    const originalWidth = parentCol?.width;
    if (parentCol) {
      parentCol.hidden = false;
      if (!parentCol.width) parentCol.width = 80;
    }

    await exportService!.exportToExcel({
      filename: (costDatabase as { name?: string }).name,
    });

    if (parentCol) {
      parentCol.hidden = originalHidden;
      parentCol.width = originalWidth;
    }
  };

  async function handleExportExcel() {
    if (source == itemListSources.COST_DATABASE) {
      handleCostDatabaseExcelExport();
      return;
    }
    const data: { estimateId: string; versionId?: string } = { estimateId: estimateId as string };
    if (estimateVersionId) {
      data.versionId = estimateVersionId;
    }
    const [responseData, estimateTotal, additionalCostTotal] = await Promise.all([
      getEstimateItemsRemoteData({ params: data }),
      fetchEstimateTotal(data),
      fetchEstimateAdditionalCostTotal(data),
    ]);

    const IsHSN_SACColumnVisible = treeGridRef.current.slickGrid.columns.find((col) => col.id == "HSN_SAC");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Estimate");
    let headers = [
      "S.No",
      "Code",
      "Description",
      "Quantity",
      "Unit",
      `Rate (${currencyData.selectedSymbol.name})`,
      `Amount (${currencyData.selectedSymbol.name})`,
    ];

    if (IsHSN_SACColumnVisible) {
      headers.splice(2, 0, "HSN/SAC");
    }
    worksheet.addRow(headers);
    const dataRows: Array<Array<string | number | undefined | null>> = [];
    ((responseData.data.result ?? []) as EstimateItem[]).map((data: EstimateItem) => {
      const eachRowData: Array<string | number | undefined | null> = [
        getSerial(responseData.data.result as EstimateItem[], data.itemId),
        data.code,
        data.description ? data.description.replace(/,/g, "") : "",
        data.hasChild
          ? ""
          : parseFloat(
              (
                parseFloat(String(data.manualQuantity || 0)) + parseFloat(String(data.quantityFromTakeoffs || 0))
              ).toFixed(2),
            ),
        data.purchaseUnit?.name || "",
        data.rate,
        parseFloat(String(data.amount)).toFixed(2),
      ];
      if (IsHSN_SACColumnVisible) {
        eachRowData.splice(2, 0, data.HSN_SAC);
      }
      dataRows.push(eachRowData);
    });

    dataRows.sort(dottedNumericSort);

    dataRows.forEach((row) => {
      worksheet.addRow(sanitizeCsvRow(row));
    });
    const amountColumnIndex = IsHSN_SACColumnVisible ? 7 : 6;

    const totalRow = Array(headers.length).fill("");
    totalRow[0] = "Total";
    totalRow[amountColumnIndex] = getEstimateNumberValueBasedOnSettings(
      estimateTotal ?? 0,
      estimateDataRef.current,
      "amount",
    );
    worksheet.addRow(totalRow);
    const additionalCostRow = Array(headers.length).fill("");
    additionalCostRow[0] = "Total Amount from additional costs";
    additionalCostRow[amountColumnIndex] = getEstimateNumberValueBasedOnSettings(
      parseFloat(String(additionalCostTotal)),
      estimateDataRef.current,
      "amount",
    );
    worksheet.addRow(additionalCostRow);
    const grandTotalRow = Array(headers.length).fill("");
    grandTotalRow[0] = "Grand Total";
    grandTotalRow[amountColumnIndex] = getEstimateNumberValueBasedOnSettings(
      (estimateTotal ?? 0) + parseFloat(String(additionalCostTotal)),
      estimateDataRef.current,
      "amount",
    );
    worksheet.addRow(grandTotalRow);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${estimateData.counter}-${estimateData.name}.xlsx`;
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  }

  function openDsrPopupFn(parentId: string, level: number) {
    setDsrPopupParent({ parentId, level });
    setOpenDsrPopup(true);
  }

  function getSerialForParentInPreviewMode(parentId: string, level: number): string | null {
    if (level < 0) {
      return null;
    }

    const recordsAtCurrentLevel = treeGridRef.current.slickGrid.data.items.filter(
      (record: EstimateItem) => record.itemLevel == level,
    );
    const parentRecord = recordsAtCurrentLevel.find((record: EstimateItem) => record.itemId === parentId);

    if (!parentRecord) {
      return null;
    }

    const { parentId: grandParentId, serial } = parentRecord;

    let result = `${serial}`;

    result = getSymbolForNumber(serial, estimateDataRef.current.settings!.numberingSystem![level], 0);

    const grandParentSerial = getSerialForParentInPreviewMode(grandParentId as string, level - 1);

    if (grandParentSerial) {
      result = `${grandParentSerial}.${result}`;
    }

    return result;
  }

  function serialTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    const { serial, parentId, itemLevel } = params;
    let result: string | number | undefined = serial;
    result = getSymbolForNumber(
      serial as number,
      (estimateDataRef.current.settings as NonNullable<EstimateData["settings"]>).numberingSystem?.[
        itemLevel as number
      ],
      0,
    );

    const parentSerial = getSerialForParentInPreviewMode(parentId as string, (itemLevel as number) - 1);

    return parentSerial ? `${parentSerial}.${result}` : `${result}`;
  }

  // useEffect(()=>{
  //   console.log(editingRowValue)
  // },[editingRowValue])

  const updateEditRowData = (field: keyof EstimateItem | string, event: React.ChangeEvent<HTMLInputElement>) => {
    setEditingRowValue((prev) => ({ ...prev, [field]: event.target.value }));
  };
  const textEditTemplate = (field: keyof EstimateItem | string) => (
    <TextFieldComponent
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateEditRowData(field, e)}
      variant="outlined"
      defaultValue={(editingRowValueRef.current as EstimateItem)[field as keyof EstimateItem] as string | undefined}
    />
  );

  function unitTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    const { hasChild, purchaseUnit } = params;
    const res =
      ((source === itemListSources.ESTIMATE || source === itemListSources.PREVIEW_BOQ_ITEMS) && hasChild) ||
      !purchaseUnit?.name
        ? null
        : purchaseUnit?.name;
    return res;
  }

  const handleQuantityChange = ({
    event,
    args,
    params,
  }: {
    event: React.FocusEvent<HTMLInputElement> | { target?: { value?: string; ariaValueMax?: string } };
    params: EstimateItem;
    args: { max: number };
  }) => {
    if (!getCustomBoqQuantity) {
      return;
    }
    const key: string = params.uniqueId || params.itemId;
    const target = (event as { target?: { value?: string; ariaValueMax?: string } })?.target;
    const value = Number(String(target?.value ?? "").replace(/,/g, ""));

    if (value <= args.max) {
      quantityVals.current[key] = value;
      getCustomBoqQuantity({
        itemId: params.itemId,
        originalTaskId: taskId,
        inspectionId: params.inspectionId,
        progressUpdateId: params.progressUpdateId,
        value,
      });
    }
  };

  const truncateTo3Decimals = (value: number) => Math.trunc(value * 1000) / 1000;

  const remainingQuantityTemplate = (
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) => {
    const {
      hasChild,
      manualQuantity = 0,
      quantityFromTakeoffs = 0,
      quantityUsedInThisContract = 0,
      availableQuantity = 0,
    } = params;
    if (hasChild) {
      return "";
    }
    let res: string | number =
      contractDetails.parentId == null
        ? truncateTo3Decimals(
            Number(quantityFromTakeoffs) + Number(manualQuantity) - Number(quantityUsedInThisContract),
          )
        : truncateTo3Decimals(availableQuantity);

    if (source === itemListSources.PREVIEW_BOQ_ITEMS || taskLinking || formLinking) {
      res = truncateTo3Decimals(availableQuantity);
    }
    return res;
  };

  const totalQuantityTemplate = (
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) => {
    const { hasChild, manualQuantity = 0, quantityFromTakeoffs = 0, revisedQuantity = 0, totalQuantity } = params;
    const res = hasChild
      ? null
      : totalQuantity || revisedQuantity || (manualQuantity ?? 0) + (quantityFromTakeoffs ?? 0);
    return res?.toFixed(2);
  };

  const handleOnMouseWheel = (e: React.WheelEvent) => {
    e.preventDefault();
  };

  function quantityTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    const {
      itemId,
      uniqueId,
      hasChild,
      manualQuantity = 0,
      quantityFromTakeoffs = 0,
      isAlreadyAddedInThisContract,
      quantityUsedInThisContract,
      availableQuantity = 0,
      isAlreadyLinkedWithThisWBSItem,
      isAlreadyAddedInThisTask,
      quantityInForm,
      isAlreadyAddedInThisForm,
    } = params;
    const container = document.createElement("div");
    const root = createRoot(container);

    const key = uniqueId || itemId;
    if (source == itemListSources.LINK_BOQ_ITEMS) {
      let max: number = contractDetails.parentId == null ? manualQuantity! + quantityFromTakeoffs! : availableQuantity;
      let value: number | null | undefined = quantityUsedInThisContract;
      if (taskLinking || formLinking) {
        max = parseFloat(String(availableQuantity));
      } else if (wbsOriginalItemId) {
        max = Number(manualQuantity! + quantityFromTakeoffs! - (quantityUsedInThisContract ?? 0));
        value = null;
      }
      if (!hasChild) {
        root.render(
          <Box onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
            <NumericTextBoxComponent
              value={(value || quantityVals.current[key]) as number | null | undefined}
              disabled={
                isAlreadyAddedInThisContract ||
                isAlreadyLinkedWithThisWBSItem ||
                isAlreadyAddedInThisTask ||
                isAlreadyAddedInThisForm
              }
              decimals={3}
              format="n3"
              placeholder={t("quantity")}
              min={0}
              id={key}
              max={max}
              data-max={max}
              onBlur={(event, args) => handleQuantityChange({ event, args, params })}
            />
          </Box>,
        );
      }
      return container;
    }
    if (source === itemListSources.PREVIEW_BOQ_ITEMS && preSelectedItems) {
      const value = quantityInForm ?? 0;
      const max = availableQuantity + (quantityInForm ?? 0);
      if (!hasChild) {
        if (enableQuantitySelection) {
          root.render(
            <div onClick={(e) => e.stopPropagation()}>
              <NumericTextBoxComponentAny
                onMouseWheel={handleOnMouseWheel}
                showSpinButton={false}
                placeholder={t("quantity")}
                min={0}
                decimals={3}
                format="n3"
                id={key}
                value={(value || quantityVals.current[key]) as number | null | undefined}
                max={max}
                onBlur={(event: React.FocusEvent<HTMLInputElement>, args: { max: number }) =>
                  handleQuantityChange({ event, args, params })
                }
              />
            </div>,
          );
        } else {
          root.render(<div onClick={(e) => e.stopPropagation()}>{value}</div>);
        }
      }

      return container;
    }

    if (!hasChild) {
      root.render(
        <ProviderApp>
          <BoqItemQuantityChip manualQuantity={manualQuantity} quantityFromTakeoffs={quantityFromTakeoffs} />
        </ProviderApp>,
      );
    }
    return container;
  }

  const openBreakUpModal = (event: React.MouseEvent, itemDetail: EstimateItem) => {
    event.stopPropagation();
    if (source === itemListSources.LINK_BOQ_ITEMS || source === itemListSources.PREVIEW_BOQ_ITEMS) {
      handleInfoIconClick?.({
        itemId: itemDetail.itemId,
        inspectionId: itemDetail.inspectionId,
        progressUpdateId: itemDetail.progressUpdateId,
        originalTaskId: taskId,
      });
    }
  };

  const usedQuantityTemplate = (
    _row: SlickFormatterParams[0],
    _fieldValue: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    let value: string | number = "";
    // if (source === itemListSources.LINK_BOQ_ITEMS) {
    //   value = params.totalQuantityLinked ?? 0;
    // }
    if (source === itemListSources.PREVIEW_BOQ_ITEMS) {
      value = params.totalUsedQuantity ?? "";
    }
    if (!params.hasChild) {
      root.render(
        <div className="w-full flex justify-between items-center">
          <span>{value}</span>
          <span onClick={(e) => openBreakUpModal(e, params)} className="cursor-pointer">
            <IconComponent name="details" width="1.5rem" height="1.5rem" />{" "}
          </span>
        </div>,
      );
    }
    return container;
  };

  function quantityEditTemplate() {
    return (
      <TextFieldComponent
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateEditRowData("manualQuantity", e)}
        variant="outlined"
        type="number"
        defaultValue={editingRowValueRef.current.manualQuantity as string | number | undefined}
        placeholder={t("Enter Quantity")}
      />
    );
  }

  function rateEditTemplate() {
    return (
      <TextFieldComponent
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateEditRowData("rate", e)}
        variant="outlined"
        type="number"
        defaultValue={editingRowValueRef.current.rate as string | number | undefined}
        placeholder={t("Enter Rate")}
      />
    );
  }

  function unitEditTemplate() {
    return (
      <div className="w-full" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <AutoComplete
          options={purchaseUnitsOptions}
          valueField="_id"
          getOptionLabel={(option: PurchaseUnitItem | string) =>
            (typeof option === "object" && option && (option as PurchaseUnitItem).nameWithSymbol) || ""
          }
          defaultValue={purchaseUnitsOptions.find((opt) => opt._id === editingRowValueRef.current.purchaseUnit) || null}
          onChange={(_event, newValue) => {
            const picked = newValue as PurchaseUnitItem | null;
            if (picked?._id) {
              setEditingRowValue((prev) => ({ ...prev, purchaseUnit: picked._id }));
            }
          }}
          renderInput={(inputParams) => <TextFieldComponent {...inputParams} placeholder={t("Select Unit")} />}
          width="100%"
          sx={{ width: "100%", minWidth: "6.25rem" }}
        />
      </div>
    );
  }

  const handleOpenRateAnalysisModal = (params: EstimateItem) => (e: React.MouseEvent) => {
    e.stopPropagation();
    if (addonsAccess.allowed) {
      const obj: {
        checkedRecord: {
          code?: string | null;
          description?: string;
          parentId?: string | null;
          purchaseUnit?: EstimateItem["purchaseUnit"];
        };
        parentRecord?: { code?: string; description?: string };
      } = {
        checkedRecord: {
          code: params.code,
          description: params.description,
          parentId: params.parentId,
          purchaseUnit: params.purchaseUnit,
        },
      };
      if (params.parentId && params.parentItem) {
        obj.parentRecord = {
          code: params.parentItem.code,
          description: params.parentItem.description,
        };
      }
      generateRateAnalysisFields(params);
      setOpenRateAnalysisModal(true);
      setItemForRateAnalysisData(params);
    } else {
      dispatch(
        showToastNotification({
          content: t("addons_access_text_normal", { name: ADDONS_DISPLAY_NAME[RATE_ANALYSIS_ADDON_CODE] }),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const handleCloseRateAnalysisModal = () => {
    setOpenRateAnalysisModal(false);
  };

  const saveRateAnalysisForItem = async ({ data }: { data: RateAnalysisPayload }) => {
    if (source === itemListSources.COST_DATABASE) {
      const newRate = data.rateAnalysisData.say;
      const response = await saveItemDetails({
        itemId: itemForRateAnalysisData.itemId as string,
        rate: newRate,
        sourceId: source === itemListSources.COST_DATABASE ? (dsrId as string) : (estimateId as string),
        source: source == itemListSources.COST_DATABASE ? DSR_LEVEL_MEASUREMENT_UNIT : ESTIMATE_LEVEL_MEASUREMENT_UNIT,
        rateAnalysis: data,
      });

      if (response.data.status) {
        fetchCostDatabase?.();
        updateItemsListData({ action: "update", data: response.data.result as EstimateItem });
        // await fetchVersionsOfDsr();
        // changeEstimateFooterKey

        handleCloseRateAnalysisModal();
      } else {
        dispatch(
          showToastNotification({
            content: untranslated(response.data.errorMessage ?? "An error occurred"),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    }
  };

  function estimateRateTemplate(params: EstimateItem) {
    const { rate, hasChild } = params;
    return hasChild || rate === null
      ? null
      : source === itemListSources.ESTIMATE || source === itemListSources.BOQ_PRINT
        ? getEstimateNumberValueBasedOnSettings(parseFloat(String(rate)), estimateDataRef.current, "rate")
        : parseFloat(parseFloat(String(rate)).toFixed(2));
  }

  function rateTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    if (
      source === itemListSources.ESTIMATE ||
      source === itemListSources.BOQ_PRINT ||
      source === itemListSources.LINK_BOQ_ITEMS ||
      source === itemListSources.PREVIEW_BOQ_ITEMS
    ) {
      return estimateRateTemplate(params);
    } else {
      return dsrRateTemplate(params);
    }
  }

  function dsrRateTemplate(params: EstimateItem) {
    const container = document.createElement("div");
    container.classList.add("w-full");
    const root = createRoot(container);

    const { rate } = params;

    root.render(
      <div className="group h-full flex justify-between items-center">
        <span>{rate !== null ? parseFloat(parseFloat(String(rate)).toFixed(2)) : ""}</span>
        <span className="invisible group-hover:visible">
          {!showOnlyGrid && source === itemListSources.COST_DATABASE && (
            <IconComponent
              name="openInViewer"
              className="cursor-pointer"
              onClick={handleOpenRateAnalysisModal(params)}
              width="1rem"
              height="1rem"
            />
          )}
        </span>
      </div>,
    );

    return container;
  }

  function remainingAmountTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    const {
      hasChild,
      manualQuantity = 0,
      quantityFromTakeoffs = 0,
      amount,
      additionalAmount,
      rate,
      availableQuantity = 0,
      quantityUsedInThisContract,
      remainingAmount = 0,
    } = params;
    if (params.hasChild && contractId) {
      if (source === itemListSources.PREVIEW_BOQ_ITEMS) {
        const allChildren = parentChildMap.current[params.itemId] ?? [];
        const totalAmount = getTotal(allChildren, "remainingAmount");
        return Number(totalAmount.toFixed(2));
      }
      return "";
    }
    if (source === itemListSources.PREVIEW_BOQ_ITEMS) {
      return parseFloat(remainingAmount.toFixed(2));
    }

    if (contractId && itemListSources.LINK_BOQ_ITEMS && contractDetails.parentId && !taskLinking && !formLinking) {
      const amountToShow = availableQuantity * (rate as number);
      ("");
      return parseFloat(amountToShow.toFixed(2));
    }
    if (
      contractId &&
      itemListSources.LINK_BOQ_ITEMS &&
      !contractDetails.parentId &&
      !taskLinking &&
      !hasChild &&
      !formLinking
    ) {
      const amountToShow =
        (manualQuantity! + quantityFromTakeoffs! - (quantityUsedInThisContract as number)) * (rate as number);
      return parseFloat(amountToShow.toFixed(2));
    }
    if (
      contractId &&
      itemListSources.LINK_BOQ_ITEMS &&
      !contractDetails.parentId &&
      !taskLinking &&
      hasChild &&
      !formLinking
    ) {
      return parseFloat(
        (parseFloat(String(amount)) + (additionalAmount ? parseFloat(String(additionalAmount)) : 0)).toFixed(2),
      );
    }
    if (contractId && itemListSources.LINK_BOQ_ITEMS && (taskLinking || formLinking)) {
      const amountToShow = availableQuantity * (rate as number);
      return parseFloat(amountToShow.toFixed(2));
    }
  }

  function linkedAmountTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    if (params.hasChild) {
      const allChildren = parentChildMap.current[params.itemId] ?? [];
      const totalAmount = getTotal(allChildren, "linkedAmount");
      return Number(totalAmount.toFixed(2));
    }
    return parseFloat(parseFloat(String(params.linkedAmount ?? 0)).toFixed(2));
  }
  function amountTemplate(
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    params: EstimateItem,
  ) {
    const { amount, additionalAmount, rate, totalAmount = 0, revisedQuantity, itemId } = params;

    if (params.hasChild && contractId) {
      if (source === itemListSources.PREVIEW_BOQ_ITEMS) {
        const allChildren = parentChildMap.current[itemId] ?? [];
        const totalAmount = getTotal(allChildren, "totalAmount");
        return Number(totalAmount.toFixed(2));
      }
      return "";
    }
    if (source === itemListSources.PREVIEW_BOQ_ITEMS) {
      return parseFloat(parseFloat(String(totalAmount)).toFixed(2));
    }
    if (
      contractId &&
      source === itemListSources.LINK_BOQ_ITEMS &&
      contractDetails.parentId &&
      !taskLinking &&
      !formLinking
    ) {
      const amountToShow = (revisedQuantity as number) * (rate as number);
      return parseFloat(amountToShow.toFixed(2));
    }
    if (contractId && source === itemListSources.LINK_BOQ_ITEMS && (taskLinking || formLinking)) {
      const amountToShow = (revisedQuantity as number) * (rate as number);
      return parseFloat(amountToShow.toFixed(2));
    }

    if (source === itemListSources.LINK_BOQ_ITEMS || source === itemListSources.PREVIEW_BOQ_ITEMS) {
      return parseFloat(
        (parseFloat(String(amount)) + (additionalAmount ? parseFloat(String(additionalAmount)) : 0)).toFixed(2),
      );
    }
    return getEstimateNumberValueBasedOnSettings(
      parseFloat(String(amount)) + (additionalAmount ? parseFloat(String(additionalAmount)) : 0),
      estimateDataRef.current,
      "amount",
    );
  }

  const detailTemplate = (
    _row: SlickFormatterParams[0],
    _cell: SlickFormatterParams[1],
    _value: SlickFormatterParams[2],
    _columnDef: SlickFormatterParams[3],
    args: EstimateItem,
  ) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    if (!args.hasChild) {
      root.render(
        <div onClick={(e) => e.stopPropagation()} className="flex w-full gap-2 items-center">
          <IconComponent
            onClick={() => handleInfoClick?.(args)}
            name="details"
            width="1.5rem"
            height="1.5rem"
            className="cursor-pointer"
          />
          <div>{args.sourceFormNo}</div>
        </div>,
      );
    }
    return container;
  };

  const handleCostDatabaseItemAttach = (parentId = "0", level = 0) => {
    openDsrPopupFn(parentId, level);
  };

  const expandParentRows = (parentRecord: EstimateItem | undefined) => {
    if (parentRecord?.itemId) {
      const expandIds = parentRecord.parentsList?.map((item) => ({ itemId: item.itemId, isCollapsed: false })) ?? [];
      treeGridRef.current.treeDataService.dynamicallyToggleItemState(expandIds);
    }
  };

  const addNewRecord = (position: number, parentRecord: EstimateItem | null, level: number) => {
    if (parentRecord?.itemId) {
      const expandIds = parentRecord.parentsList?.map((item) => ({ itemId: item.itemId, isCollapsed: false })) ?? [];
      treeGridRef.current.treeDataService.dynamicallyToggleItemState(expandIds);
    }
    setToolbarButtonDisableState((prev) => ({
      ...prev,
      [BOQToolsIdsMap.ADD_TOP]: true,
      [BOQToolsIdsMap.ADD_CHILD]: true,
      [BOQToolsIdsMap.EDIT]: true,
      [BOQToolsIdsMap.DELETE]: true,
      [BOQToolsIdsMap.UPDATE]: false,
      [BOQToolsIdsMap.CANCEL]: false,
      [BOQToolsIdsMap.CHANGE_TYPE]: true,
      [BOQToolsIdsMap.MODIFY_TOTAL]: true,
      [BOQToolsIdsMap.IMPORT_EXCEL]: true,
      [BOQToolsIdsMap.PROPERTIES]: true,
      [BOQToolsIdsMap.EXPAND_ALL]: true,
      [BOQToolsIdsMap.COLLAPSE_ALL]: true,
      [BOQToolsIdsMap.EXPORT_EXCEL]: true,
      [BOQToolsIdsMap.EXPORT_PDF]: true,
    }));

    const rowToAdd = {
      action: "insert",
      position,
      id: uuid(),
      code: "",
      purchaseUnit: "",
      quantity: null,
      rate: null,
      amount: 0,
      parentId: parentRecord?.itemId ?? null,
      treeLevel: level,
      itemLevel: level,
      __hasChildren: false,
      hasChild: false,
    } as unknown as EstimateItem;
    editingRowValueRef.current = rowToAdd;
    treeGridRef.current.addRecord(rowToAdd, rowToAdd.position);
    // treeGridRef.current.dataView.addItem(rowToAdd);
    setEditingRowValue(rowToAdd);
  };

  const cancelEditRecord = (removeRecord = false) => {
    editingRowValueRef.current = {};
    if (removeRecord) {
      treeGridRef.current.removeRecord(editingRowValue.position, editingRowValue as EstimateItem);
    }
    setEditingRowValue({});
    treeGridRef.current.slickGrid.setSelectedRows([]);
    setToolbarButtonDisableState(buttonIntialState);
  };

  const setUpdateCancelButtonActiveState = (isDisable: boolean) => {
    setToolbarButtonDisableState((prev) => ({
      ...prev,
      [BOQToolsIdsMap.UPDATE]: isDisable,
      [BOQToolsIdsMap.CANCEL]: isDisable,
    }));
  };

  const handleUpdateClick = async () => {
    setUpdateCancelButtonActiveState(true);
    if (editingRowValue.action == "insert") {
      if (source == itemListSources.ESTIMATE) {
        await addRecordInEstimate();
      } else if (source == itemListSources.COST_DATABASE) {
        await addRecordInCostDatabase();
      }
    } else {
      if (source == itemListSources.ESTIMATE) {
        await editRecordInEstimate();
      } else if (source == itemListSources.COST_DATABASE) {
        await editRecordInCostDatabase();
      }
    }
  };

  const handleAddTopSelectionHandler = (args: SelectEventArgs) => {
    if (!isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id)) {
      showToastData(t("You Don't Have Required Permission to Perform this Action"));
      return;
    }
    if (args.item.id == "dsrItem") {
      handleCostDatabaseItemAttach();
    } else {
      addNewRecord(0, null, 0);
    }
  };

  const handleAddChildSelectionHandler = (args: SelectEventArgs) => {
    if (!isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id)) {
      showToastData(t("You Don't Have Required Permission to Perform this Action"));
      return;
    }
    const selectedRecord = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy)[0]!;
    if (args.item.id === "dsrItem") {
      handleCostDatabaseItemAttach(selectedRecord.id, (selectedRecord.itemLevel as number) + 1);
    } else {
      expandParentRows(selectedRecord);
      const selectedRows = treeGridRef.current.slickGrid.getSelectedRows();
      const position = selectedRows.length ? selectedRows[selectedRows.length - 1]! : 0;
      addNewRecord(position + 1, selectedRecord, (selectedRecord.itemLevel as number) + 1);
    }
  };

  const rowSelectedHandler = () => {
    if (_.get(treeGridRef, "current.slickGrid") && !editingRowValueRef.current.action) {
      const selectedRecords = treeGridRef.current.dataView
        .getAllSelectedItems()
        .filter((record: EstimateItem) => record && !record.__isDummy);
      const totalSelectedRecords = selectedRecords.length;

      const buttonState = {
        [BOQToolsIdsMap.DELETE]: totalSelectedRecords > 0,
        [BOQToolsIdsMap.ADD_CHILD]: totalSelectedRecords == 1,
        [BOQToolsIdsMap.EDIT]: totalSelectedRecords == 1,
        [BOQToolsIdsMap.PROPERTIES]: totalSelectedRecords == 1,
        [BOQToolsIdsMap.CHANGE_TYPE]: totalSelectedRecords == 1 && !!selectedRecords[0]!.code,
      };
      setToolBarButtonsState(buttonState);
    }
  };

  const gridSelectionHandler = () => {
    if (selectionEvent) {
      const selectedRecords = treeGridRef.current.dataView
        .getAllSelectedItems()
        .filter((record: EstimateItem) => record && !record.__isDummy);
      selectionEvent(selectedRecords);
    } else if (
      source === itemListSources.ADD_ITEM_POPUP ||
      source === itemListSources.PREVIEW_BOQ_ITEMS ||
      source === itemListSources.LINK_BOQ_ITEMS ||
      source === itemListSources.CONTRACT_CDB
    ) {
      popupTreeGridSelectionEvent();
    } else {
      rowSelectedHandler();
    }
  };

  function setToolBarButtonsState(data: { [buttonId: string]: boolean }) {
    if (_.get(treeGridRef, "current")) {
      const permissionRequiredButtons = [
        BOQToolsIdsMap.ADD_TOP,
        BOQToolsIdsMap.ADD_CHILD,
        BOQToolsIdsMap.EDIT,
        BOQToolsIdsMap.DELETE,
        BOQToolsIdsMap.UPDATE,
        BOQToolsIdsMap.MODIFY_TOTAL,
        BOQToolsIdsMap.IMPORT_EXCEL,
        BOQToolsIdsMap.CHANGE_TYPE,
      ];
      Object.keys(data).map((button) => {
        let state = data[button];
        if (
          source == itemListSources.ESTIMATE &&
          permissionRequiredButtons.includes(button) &&
          !isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id)
        ) {
          state = false;
        } else if (
          ["export_excel, export_pdf"].includes(button) &&
          !isEstimateRequiredPermission(estimateData, RESOURCE_DOWNLOAD.id)
        ) {
          state = false;
        }
        data[button] = !state;
      });
      setToolbarButtonDisableState((prev) => ({ ...prev, ...data }));
    }
  }

  const startEditing = (selectedRecord: EstimateItem) => {
    if (source === itemListSources.ESTIMATE) {
      setEditItem({ show: true, data: selectedRecord });
    } else if (source === itemListSources.COST_DATABASE) {
      if (selectedRecord?.parentId) {
        expandParentRows(selectedRecord);
      }
      setToolbarButtonDisableState((prev) => ({
        ...prev,
        [BOQToolsIdsMap.ADD_TOP]: true,
        [BOQToolsIdsMap.ADD_CHILD]: true,
        [BOQToolsIdsMap.EDIT]: true,
        [BOQToolsIdsMap.DELETE]: true,
        [BOQToolsIdsMap.UPDATE]: false,
        [BOQToolsIdsMap.CANCEL]: false,
        [BOQToolsIdsMap.MODIFY_TOTAL]: true,
        [BOQToolsIdsMap.IMPORT_EXCEL]: true,
        [BOQToolsIdsMap.PROPERTIES]: true,
        [BOQToolsIdsMap.EXPAND_ALL]: true,
        [BOQToolsIdsMap.COLLAPSE_ALL]: true,
        [BOQToolsIdsMap.EXPORT_EXCEL]: true,
        [BOQToolsIdsMap.EXPORT_PDF]: true,
      }));
      const rowData = {
        id: selectedRecord.id,
        code: selectedRecord.code,
        purchaseUnit: selectedRecord.purchaseUnit?.id,
        rate: selectedRecord.rate,
        description: selectedRecord.description,
        itemId: selectedRecord.itemId,
        // parentId,
        // treeLevel: level,
        // hasChild: false,
        // ...selectedRecords[0],
        action: "update",
      };
      editingRowValueRef.current = rowData;
      setEditingRowValue(rowData);
    }
  };

  const toolBarClickHandlerNew = (toolClicked: ToolbarButtonId) => {
    if (!treeGridRef.current) return;
    if (source === itemListSources.ESTIMATE) {
      if (
        ([
          BOQToolsIdsMap.EDIT,
          BOQToolsIdsMap.DELETE,
          BOQToolsIdsMap.UPDATE,
          BOQToolsIdsMap.MODIFY_TOTAL,
          BOQToolsIdsMap.IMPORT_EXCEL,
          BOQToolsIdsMap.CHANGE_TYPE,
        ].includes(toolClicked) &&
          !isEstimateRequiredPermission(estimateData, RESOURCE_MODIFY.id)) ||
        ([BOQToolsIdsMap.EXPORT_EXCEL, BOQToolsIdsMap.EXPORT_PDF].includes(toolClicked) &&
          !isEstimateRequiredPermission(estimateData, RESOURCE_DOWNLOAD.id))
      ) {
        showToastData(t("You Don't Have Required Permission to Perform this Action"));
        return;
      }
    }
    const selectedRecords = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);

    if (
      [BOQToolsIdsMap.ADD_TOP, BOQToolsIdsMap.ADD_CHILD].includes(toolClicked) &&
      source == itemListSources.COST_DATABASE
    ) {
      if (toolClicked == BOQToolsIdsMap.ADD_TOP) {
        addNewRecord(0, null, 0);
      } else {
        expandParentRows(selectedRecords[0]);
        const selectedRows = treeGridRef.current.slickGrid.getSelectedRows();
        const position = selectedRows.length ? selectedRows[selectedRows.length - 1]! : 0;
        addNewRecord(position + 1, selectedRecords[0]!, (selectedRecords[0]!.itemLevel as number) + 1);
      }
    } else if (toolClicked == BOQToolsIdsMap.EDIT) {
      startEditing(selectedRecords[0]!);
    } else if (toolClicked == BOQToolsIdsMap.CANCEL) {
      cancelEditRecord(editingRowValue.action == "insert");
    } else if (toolClicked == BOQToolsIdsMap.DELETE) {
      setOpenModalPopup(true);
    } else if (toolClicked == BOQToolsIdsMap.UPDATE) {
      handleUpdateClick();
    } else if (toolClicked === BOQToolsIdsMap.MODIFY_TOTAL) {
      setShowAdditionalCosts(true);
    } else if (toolClicked === BOQToolsIdsMap.IMPORT_EXCEL) {
      handleImportExcel();
    } else if (toolClicked === BOQToolsIdsMap.PROPERTIES) {
      if (selectedRecords.length === 1) {
        openSidebar(selectedRecords[0]!);
      }
    } else if (toolClicked === BOQToolsIdsMap.CHANGE_TYPE) {
      handleTypeChange();
    } else if (toolClicked === BOQToolsIdsMap.EXPAND_ALL) {
      treeGridRef.current.treeDataService.toggleTreeDataCollapse(false);
    } else if (toolClicked === BOQToolsIdsMap.COLLAPSE_ALL) {
      treeGridRef.current.treeDataService.toggleTreeDataCollapse(true);
    } else if (toolClicked === BOQToolsIdsMap.EXPORT_EXCEL) {
      handleExportExcel();
    } else if (toolClicked === BOQToolsIdsMap.EXPORT_PDF) {
      handleExportPdf();
    }
  };

  const showToastData = (content: string) => {
    dispatch(
      showToastNotification({
        content: untranslated(content),
        type: TOAST_TYPE_ERROR,
      }),
    );
  };

  const updateToolbarButtonsOnCancel = () => {
    setToolBarButtonsState({ update: true, cancel: true });
  };

  const handleDelete = async () => {
    const selectedRecords = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);
    if (!selectedRecords.length) {
      return;
    }
    setButtonLoading(true);

    type DeletePayload = {
      params: { estimateId?: string; dsrId?: string };
      action: "remove";
      key: string[];
    };
    const payloadData: DeletePayload = {
      params: { estimateId },
      action: "remove",
      key: selectedRecords.map((item: EstimateItem) => item.itemId),
    };

    let response: Awaited<ReturnType<typeof deleteCostDatabaseItems>> | Awaited<ReturnType<typeof saveItemInEstimate>>;
    if (source === itemListSources.COST_DATABASE) {
      response = await deleteCostDatabaseItems({ key: payloadData.key, params: { dsrId } });
    } else {
      payloadData.params = { estimateId };
      response = await saveItemInEstimate(payloadData as Parameters<typeof saveItemInEstimate>[0]);
    }

    if (response.data.status) {
      let currentStateDataForMultipleOps: EstimateItem[] | undefined = _.cloneDeep(staticDataSource);

      const seprateRootRecordsSelected = selectedRecords.filter(
        (item: EstimateItem) =>
          !item.parentsList?.some((ele) => selectedRecords.some((val: EstimateItem) => val.itemId === ele.itemId)),
      );

      for (const itemData of seprateRootRecordsSelected) {
        currentStateDataForMultipleOps = await updateItemsListData({
          action: "delete",
          data: itemData,
          performCommonAction: itemData.itemId == seprateRootRecordsSelected.at(-1)?.itemId,
          currentStateDataForMultipleOps,
        });
      }
      setStaticDataSource(currentStateDataForMultipleOps);
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage || "Delete item failed please retry!"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
    setButtonLoading(false);
    closeDeleteModalPopup({ isDeleted: true });
  };

  const closeDeleteModalPopup = (params?: { isDeleted?: boolean }) => {
    if (!_.get(params, "isDeleted")) {
      const buttonState = {
        add_top: true,
        edit_item: true,
        update: false,
        add_child: true,
        delete: true,
        cancel: false,
        modify_total: true,
        item_properties: true,
      };
      setToolBarButtonsState(buttonState);
    }
    setOpenModalPopup(false);
  };

  const rowDrop = async (_e: Event, params: { rows: number[]; insertBefore: number }) => {
    const data = treeGridRef.current.dataView.items;
    const currentDragRowData = data[params.rows[0]!]!;
    const droppedRowIndex = params.insertBefore === 0 ? null : params.insertBefore - 1;
    const droppedRowData = droppedRowIndex == null ? null : data[droppedRowIndex];
    const targetRowParentId = droppedRowData?.parentId || null;

    if (currentDragRowData.parentId == targetRowParentId) {
      const payload: {
        fromIndex: number;
        dropIndex: number;
        itemId: string;
        parentId: string | null;
        estimateId?: string;
      } = {
        fromIndex: (currentDragRowData.serial as number) - 1,
        dropIndex: droppedRowData ? (droppedRowData.serial as number) : 0,
        itemId: currentDragRowData.itemId,
        parentId: currentDragRowData.parentId || "0",
        estimateId,
      };

      if (payload.fromIndex == payload.dropIndex) {
        return;
      }

      const res = await updatedEstimateItemSerial(payload as Parameters<typeof updatedEstimateItemSerial>[0]);

      if (res.data.status) {
        payload.parentId = payload.parentId === "0" ? null : payload.parentId;
        updateItemsListData({ action: "reorder", data: payload as EstimateItem });
      }
    }
  };

  function actionCompleteHandler() {
    if (source === itemListSources.COST_DATABASE) {
      fetchCostDatabase!();
      fetchVersionsOfDsr!();
    }

    if (source === itemListSources.ESTIMATE) {
      dispatch(getEstimateData({ estimateId: estimateId!, versionId: estimateVersionId }));
      changeEstimateFooterKey();
    }
  }

  const handleToogleSwitch = (args: { target: { checked: boolean } }) => {
    setAutoPopulateState?.(args.target.checked);
    let isToggleOn = false;
    if (args.target.checked) {
      isToggleOn = true;
    }
    const selectedRows = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);
    for (const item of selectedRows) {
      const key = item.uniqueId || item.itemId;
      const numericTextBoxElement = document.getElementById(`${key}`) as HTMLInputElement | null;
      if (numericTextBoxElement) {
        const max = Number(numericTextBoxElement.getAttribute("data-max") ?? 0);
        numericTextBoxElement.value = String(isToggleOn ? max : 0);
        quantityVals.current[key] = String(isToggleOn ? max : 0);
      }
    }
  };

  const toggleTemplate = () => (
    <ToggleSwitchComponent onChange={handleToogleSwitch} label={t("Auto populate all available quantity")} />
  );

  const titleFormatter = (
    data: SlickFormatterParams[0],
    value: SlickFormatterParams[1],
    a: SlickFormatterParams[2],
    b: SlickFormatterParams[3],
    args: EstimateItem,
  ) => {
    return serialTemplate(data, value, a, b, args);
  };

  const itemsBeforeDataBound = useCallback(
    (response: { data: { result: EstimateItem[] } }) => {
      if (
        source === itemListSources.ADD_ITEM_POPUP ||
        source === itemListSources.LINK_BOQ_ITEMS ||
        source === itemListSources.PREVIEW_BOQ_ITEMS ||
        source === itemListSources.CONTRACT_CDB
      ) {
        return response.data.result.map((item: EstimateItem) => {
          if (
            item.allowSelection === false ||
            item.isAlreadyAddedInThisContract ||
            item.isAlreadyLinkedWithThisWBSItem ||
            item.isAlreadyAddedInThisTask ||
            item.isAlreadyAddedInThisForm
          ) {
            item.disableSelection = true;
          }
          return item;
        });
      }
      return response.data.result;
    },
    [source],
  );

  const treeGridData = () => (
    <div className={cssClass ?? "flex w-full h-full"}>
      <SlickGrid
        // TreeGridRef is a narrow duck-type of SlickgridReactInstanceX; TS requires
        // the canonical 2-step `unknown` bridge for this non-overlapping cast at
        // the wrapper boundary. The runtime ref is the full Slickgrid instance.
        ref={treeGridRef as unknown as React.RefObject<SlickgridReactInstanceX<EstimateItem>>}
        // disabledIds = {disableIds}
        enableSelectAllCheckbox={enableSelectAll}
        disableTreeCollapseOnDataChange
        initiallyExpanded={source === itemListSources.BOQ_PRINT || source === itemListSources.PREVIEW_BOQ_ITEMS}
        treeGrid
        showLoader={showGridLoader}
        disableMenuOptions={disableMenuOptions}
        disableFullHeight={source == itemListSources.BOQ_PRINT || growToContent}
        titleFormatter={
          source === itemListSources.ESTIMATE ||
          source === itemListSources.LINK_BOQ_ITEMS ||
          source === itemListSources.PREVIEW_BOQ_ITEMS
            ? titleFormatter
            : undefined
        }
        initialSortColumnId="createdDate"
        dataset={staticDataSource}
        remoteDataSource={remoteDataSource}
        query={remoteQuery as QueryShape | undefined}
        columnDefinitions={gridColumns as ValidatedColumnDefinition<EstimateItem>[] | null}
        showPageCount={source !== itemListSources.BOQ_PRINT}
        beforeDataBound={
          itemsBeforeDataBound as (
            resp: Parameters<NonNullable<Parameters<typeof SlickGrid>[0]["beforeDataBound"]>>[0],
          ) => EstimateItem[]
        }
        gridOptions={{
          // rowHeight : 50,
          enableSorting: true,
          forceFitColumns: true,
          enableAutoSizeColumns: true,
          enableCheckboxSelector:
            ![itemListSources.BOQ_PRINT, itemListSources.ESTIMATE_ATTACHED_CD_PREVIEW].includes(
              source as "boqPrint" | "estimateCDPreview",
            ) && enableCheckboxSelector,
          enableRowSelection: true,
          autoHeight: source == itemListSources.BOQ_PRINT || growToContent,
          // enableRowMoveManager: source == itemListSources.ESTIMATE && !estimateVersionId && !showOnlyGrid,
          rowMoveManager: {
            columnIndexPosition: 0,
            cancelEditOnDrag: true,
            disableRowSelection: true,
            hideRowMoveShadow: false,
            onMoveRows: (e: Event, args: { rows: number[]; insertBefore: number }) => {
              rowDrop(e, args);
            },
          },
        }}
        // initialSortDirection="ASC"
        allowPagination={false}
        hasChildMapping="hasChild"
        parentIdMapping={childParentMapper.parentId}
        idMapping={childParentMapper.itemId}
        levelPropName="itemLevel"
        enableFilteringOption={enableFilteringOption}
        enableSortingOption={enableSortingOption}
        enableColumnChooser={enableColumnChooser}
        enableGridMenu={false}
        enableRowResize={enableRowResize}
        enableWrapText={isWrapTextActive}
        setEnableWrapText={setIsWrapTextActive}
        disableChildDataFetch
        onSelectedRowIdsChanged={gridSelectionHandler}
        toolbar={(showOnlyGrid ? undefined : toolbar) as React.ComponentProps<typeof SlickGrid>["toolbar"]}
        toolbarClickHandler={toolBarClickHandlerNew}
        enableFiltering={true}
        setGridReady={setIsGridReady}
        isEditMode={!!editingRowValue.action}
      />
    </div>
  );

  const modelContent = () => {
    const selectedRecords = treeGridRef.current.dataView
      .getAllSelectedItems()
      .filter((record: EstimateItem) => record && !record.__isDummy);
    const isWarningExists = selectedRecords.some((item: EstimateItem) => Number.isFinite(item.quantityFromTakeoffs));

    return (
      <div className="flex flex-col font-normal text-sm gap-5">
        <Text sx={{ whiteSpace: "normal" }}>{t("Are you sure you want to delete the selected Item(s)?")}</Text>
        {isWarningExists && (
          <Text
            sx={{ whiteSpace: "normal" }}
            className="p-4 rounded-lg bg-system_colour_47 bg-opacity-40 border border-banner_color_yellow"
          >
            {t(
              "Deleting this item(s) will remove it from the Takeoff(s), but the Takeoff(s) itself will not be deleted",
            )}
          </Text>
        )}
      </div>
    );
  };

  const deleteItemModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <div className="flex gap-4">
          <ButtonComponent onClick={handleDelete} buttonType={BUTTON_TYPES.GRADIENT_BUTTON} loading={buttonLoading}>
            {t("Confirm")}
          </ButtonComponent>
          <ButtonComponent
            onClick={closeDeleteModalPopup}
            buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
            disabled={buttonLoading}
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      headerTitle={t("Delete Item(s)")}
      isVisible={openModalPopup}
      onCancel={buttonLoading ? undefined : closeDeleteModalPopup}
      modelContent={modelContent()}
      width="28.125rem"
    />
  );

  useEffect(() => {
    if (source === itemListSources.ESTIMATE && treeGridRef.current) {
      refreshDataGrid(true);
    }
  }, [stateToUpdateBoqDatasource]);

  const closeEditModalPopUp = () => {
    setEditItem({ show: false, data: {} });
  };

  const editItemRefreshCallback = (data: EstimateItem) => {
    updateItemsListData({ action: "update", data });
    dispatch(getEstimateData({ estimateId: estimateId! }));
    closeEditModalPopUp();
  };

  return (
    <>
      <div className="flex h-full w-full overflow-auto flex-col">
        {showAdditionalCosts && source === itemListSources.ESTIMATE && (
          <ModalStateDialogComponent
            width="50rem"
            headerTitle={t("Additional Costs")}
            onCancel={closeAdditionalCostModal}
            modelContent={
              <AdditionalCostsList
                currencyData={currencyData as React.ComponentProps<typeof AdditionalCostsList>["currencyData"]}
              />
            }
            isVisible
          />
        )}
        {editItem.show && (
          <BoqItemEditPopUp
            closeEditModalPopUp={closeEditModalPopUp}
            itemDetails={editItem.data as React.ComponentProps<typeof BoqItemEditPopUp>["itemDetails"]}
            currencyDetails={currencyData}
            refreshCallBack={
              editItemRefreshCallback as React.ComponentProps<typeof BoqItemEditPopUp>["refreshCallBack"]
            }
          />
        )}

        {showFileUploadModal && (
          <ExcelImport
            showImportModal={showFileUploadModal}
            setShowImportModal={setShowFileUploadModal}
            source={
              source === itemListSources.ESTIMATE ? excelImportSources.ESTIMATE : excelImportSources.COST_DATABASE
            }
            sourceId={source === itemListSources.ESTIMATE ? estimateId : dsrId}
            refreshDataGrid={refreshDataGrid}
            currentData={undefined}
          />
        )}

        {incorrectlyPlacedItems.show && (
          <IncorrectlyPlacedItemsModal
            closeModal={closeIncorrectPlacedItemsModal}
            successCallback={saveItemsWithCorrectPlacement}
          />
        )}

        {openDsrPopup && (
          <DsrPopup
            {...dsrPopupParent}
            estimateId={estimateId!}
            handleDiscardItemAdditionFromPopup={handleDiscardItemAdditionFromPopup}
            // `DsrPickerItem` is the loose picker shape; runtime values are the
            // full BOQ EstimateItem rows. Wrap the async handler so the prop
            // signature (void return, DsrPickerItem[] param) is satisfied.
            handleItemAdditionFromPopup={(items) => {
              void handleItemAdditionFromPopup(items as EstimateItem[]);
            }}
            currencyData={currencyData}
            buttonLoadingState={buttonLoading}
          />
        )}

        {openItemPropertiesSidebar.status && openItemPropertiesSidebar.data._id && (
          <EstimationDetails
            canEdit={canEdit}
            closeSidebar={closeSidebar}
            rateAnalysisItemsData={
              rateAnalysisItemsData as React.ComponentProps<typeof EstimationDetails>["rateAnalysisItemsData"]
            }
            changeEstimateFooterKey={changeEstimateFooterKey}
            refreshDataGrid={refreshDataGrid}
            data={openItemPropertiesSidebar.data as React.ComponentProps<typeof EstimationDetails>["data"]}
            dsrItemData={
              [openItemPropertiesSidebar.data] as React.ComponentProps<typeof EstimationDetails>["dsrItemData"]
            }
            sourceId={source === itemListSources.COST_DATABASE ? dsrId : estimateId}
            source={
              source === itemListSources.COST_DATABASE ? DSR_LEVEL_MEASUREMENT_UNIT : ESTIMATE_LEVEL_MEASUREMENT_UNIT
            }
            costDatabaseVersionId={
              source === itemListSources.COST_DATABASE
                ? (costDatabaseState.costDBversionId as string | undefined)
                : estimateCostDatabaseVersionId
            }
            fetchCostDatabase={fetchCostDatabase as React.ComponentProps<typeof EstimationDetails>["fetchCostDatabase"]}
            updateItemsListData={
              updateItemsListData as React.ComponentProps<typeof EstimationDetails>["updateItemsListData"]
            }
            currencyData={currencyData}
          />
        )}

        {((source !== itemListSources.ESTIMATE &&
          source !== itemListSources.BOQ_PRINT &&
          source !== itemListSources.LINK_BOQ_ITEMS &&
          source !== itemListSources.PREVIEW_BOQ_ITEMS) ||
          estimateData._id) &&
          gridColumns &&
          treeGridData()}
        {openModalPopup && deleteItemModal()}
      </div>
      {source === itemListSources.ESTIMATE && showGrandTotalFooter && (
        <EstimationFooter key={estimationFooterKey} currencyData={currencyData} estimateId={estimateId} />
      )}

      {openRateAnalysisModal && (
        <ModalStateDialogComponent
          isVisible={openRateAnalysisModal}
          allowModalPadding={false}
          onCancel={handleCloseRateAnalysisModal}
          headerTitle={
            <div className=" w-full flex justify-between items-center">
              <span>{t("Rate Analysis")}</span>
            </div>
          }
          width="90%"
          modelContent={
            <div className="">
              <Suspense fallback={<></>}>
                <RateAnalysis
                  rateAnalysisItemsData={
                    rateAnalysisItemsData as React.ComponentProps<typeof RateAnalysis>["rateAnalysisItemsData"]
                  }
                  currencyData={currencyData}
                  saveRateAnalysisForItem={saveRateAnalysisForItem}
                  handleCloseRateAnalysisModal={handleCloseRateAnalysisModal}
                  rateAnalysis={
                    itemForRateAnalysisData.rateAnalysis as React.ComponentProps<typeof RateAnalysis>["rateAnalysis"]
                  }
                  viewMode={
                    !canEdit ||
                    Boolean(dsrVersionId) ||
                    (source === ESTIMATE_LEVEL_MEASUREMENT_UNIT &&
                      (itemForRateAnalysisData.code !== null || Boolean(estimateVersionId)))
                  }
                  source={source}
                />
              </Suspense>
            </div>
          }
        />
      )}
    </>
  );
});
EstimateDsrItems.displayName = "EstimateDsrItems";
export default EstimateDsrItems;
